"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[912],{

/***/ 33081:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var EDIT = 'M20.712 7.032L18.888 8.856L15.144 5.112L16.968 3.288C17.16 3.096 17.396 3 17.676 3C17.956 3 18.192 3.096 18.384 3.288L20.712 5.616C20.904 5.808 21 6.044 21 6.324C21 6.604 20.904 6.84 20.712 7.032ZM3 17.256L14.064 6.192L17.808 9.936L6.744 21H3V17.256Z';
var IconEdit = lib.variant('IconEdit', icon.Icon, {
    path: EDIT,
});

exports.IconEdit = IconEdit;
//# sourceMappingURL=_icon-edit.js.map


/***/ }),

/***/ 3901:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var LIKE_OUTLINED = 'M13.7647 4L14.6471 4.86331C14.8693 5.08074 14.9804 5.35571 14.9804 5.68825V5.95683L14.1765 9.6211H19.3529C19.7974 9.6211 20.183 9.77458 20.5098 10.0815C20.8366 10.3885 21 10.7594 21 11.1942L20.9608 11.271H21V12.8058C21 13.0104 20.9608 13.2086 20.8824 13.4005L18.3922 19.0216C18.2876 19.3157 18.098 19.5524 17.8235 19.7314C17.549 19.9105 17.2418 20 16.902 20H9.54902C9.10457 20 8.71895 19.8401 8.39216 19.5204C8.06536 19.2006 7.90196 18.8233 7.90196 18.3885V10.4077C7.90196 9.9984 8.06536 9.6211 8.39216 9.27578L13.7647 4ZM6.29412 10.4077V20H3V10.4077H6.29412ZM13.3275 6.49891L9.49733 10.2592C9.43197 10.3283 9.41015 10.3623 9.40404 10.3888L9.40196 10.4077V18.3885C9.40196 18.4242 9.40452 18.439 9.42733 18.4652L9.45756 18.4965C9.49392 18.5321 9.50509 18.5418 9.52497 18.5445L9.54902 18.5455H16.902L16.9468 18.5421C16.9526 18.5409 16.9579 18.5393 16.963 18.5373L16.9823 18.5265L17.0139 18.4475L19.4879 12.8644L19.4973 12.8348L19.5 12.8058V11.6073L19.4983 11.5994C19.4682 11.4749 19.4547 11.3457 19.46 11.2148L19.4662 11.1265C19.4296 11.0919 19.4136 11.0806 19.3858 11.0771L19.3529 11.0756H14.1765C13.2591 11.0756 12.5659 10.2876 12.6904 9.42256L12.7093 9.31843L13.3275 6.49891Z';
var IconLikeOutlined = lib.variant('IconLikeOutlined', icon.Icon, {
    path: LIKE_OUTLINED,
});

exports.IconLikeOutlined = IconLikeOutlined;
//# sourceMappingURL=_icon-likeoutlined.js.map


/***/ }),

/***/ 56662:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(33081);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.y = index.IconEdit;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 49816:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(3901);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.q = index.IconLikeOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 73711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71406);
/* harmony import */ var src_components_spinner__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80054);




var SubmitButton = function(props) {
    var text = props.text, loading = props.loading, style = props.style, onClick = props.onClick, className = props.className, type = props.type, htmlType = props.htmlType;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__/* .PrimaryButton */ .KM, {
        className: className,
        onClick: onClick,
        style: style,
        loading: loading,
        htmlType: type || htmlType
    }, !loading && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__/* .ButtonText */ .oD, null, text), loading && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_button_variants__WEBPACK_IMPORTED_MODULE_2__/* .ButtonIcon */ .Ei, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_spinner__WEBPACK_IMPORTED_MODULE_3__/* .Spinner */ .$, {
        position: "none",
        isActive: true
    })));
};
SubmitButton.propTypes = {
    loading: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    text: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().object),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func)
};
SubmitButton.defaultProps = {
    type: "submit",
    loading: false
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SubmitButton);


/***/ }),

/***/ 62539:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ report)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(68456);
// EXTERNAL MODULE: ./src/components/modal/actions.ts
var actions = __webpack_require__(64966);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/modal/confirm.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  h2 {\n    font-size: ",
        ";\n    font-weight: 600;\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n\n  .pj-ui-text-input {\n    margin-bottom: 0;\n  }\n\n  p {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: flex-end;\n  width: 100%;\n  button {\n    white-space: nowrap;\n    margin-left: ",
        ";\n    flex: 1;\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(_templateObject());
var Title = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal);
var Body = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Body",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var Footer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/modal/confirm.js
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}








var ConfirmModal = function(_param) {
    var onCancel = _param.onCancel, onConfirm = _param.onConfirm, hideModal = _param.hideModal, props = _objectWithoutProperties(_param, [
        "onCancel",
        "onConfirm",
        "hideModal"
    ]);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        id: props.id,
        isOpen: props.isOpen,
        width: props.width,
        onRequestClose: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, /*#__PURE__*/ react.createElement(Content, null, props.title && /*#__PURE__*/ react.createElement(Title, null, /*#__PURE__*/ react.createElement("h2", null, props.title)), /*#__PURE__*/ react.createElement(Body, null, props.children), /*#__PURE__*/ react.createElement(Footer, null, props.showCancel && /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "primary",
        variant: "outlined",
        onClick: function() {
            return onCancel === undefined ? hideModal() : onCancel();
        }
    }, props.cancelLabel || t("common", "button.cancel")), /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        color: "positive",
        onClick: function() {
            return onConfirm === undefined ? hideModal() : onConfirm();
        }
    }, props.confirmLabel || t("common", "button.ok")))));
};
var func = (prop_types_default()).func, string = (prop_types_default()).string, bool = (prop_types_default()).bool, node = (prop_types_default()).node, number = (prop_types_default()).number;
ConfirmModal.propTypes = {
    hideModal: func.isRequired,
    onConfirm: func,
    onCancel: func,
    children: node,
    width: number,
    id: string,
    isOpen: bool,
    title: string,
    showCancel: bool,
    confirmLabel: string,
    cancelLabel: string
};
ConfirmModal.defaultProps = {
    onConfirm: undefined,
    onCancel: undefined,
    children: null,
    width: 400,
    id: undefined,
    isOpen: false,
    title: undefined,
    showCancel: false,
    confirmLabel: undefined,
    cancelLabel: undefined
};
/* harmony default export */ const modal_confirm = ((0,es/* connect */.$j)(null, actions/* default */.ZP)(/*#__PURE__*/ (0,react.memo)(ConfirmModal)));

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var reviews_actions = __webpack_require__(93302);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(31127);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
;// CONCATENATED MODULE: ./src/areas/reviews/components/report/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}










var ReportReviewModal = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(ReportReviewModal, _PureComponent);
    var _super = _createSuper(ReportReviewModal);
    function ReportReviewModal(props) {
        _classCallCheck(this, ReportReviewModal);
        var _this;
        _this = _super.call(this, props);
        _this.state = _this.getInitialState();
        return _this;
    }
    _createClass(ReportReviewModal, [
        {
            // eslint-disable-next-line class-methods-use-this
            key: "getInitialState",
            value: function getInitialState() {
                return {
                    errors: {},
                    message: "",
                    email: ""
                };
            }
        },
        {
            key: "sendReport",
            value: function sendReport(data) {
                var reviewId = data ? data.review : null;
                var errors = {
                    message: typeof data.message !== "string" || !data.message.trim().length,
                    email: typeof data.email !== "string" || !(0,helpers/* isValidEmail */.vV)(data.email)
                };
                if (errors.message || errors.email) {
                    this.setState({
                        errors: errors
                    });
                } else {
                    if (this.props.type === "product") {
                        (0,tracking/* productReviewReported */.mC)();
                    }
                    if (this.props.type === "store") {
                        (0,tracking/* storeReviewReported */.gK)();
                    }
                    this.props.reportReview(reviewId, data.message, data.email);
                    this.close();
                }
            }
        },
        {
            key: "close",
            value: function close() {
                this.props.onComplete();
                this.setState(this.getInitialState());
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                var errors = this.state.errors;
                var account = this.props.account;
                var email = account && account.me ? account.me.email : false;
                return /*#__PURE__*/ react.createElement(modal_confirm, {
                    isOpen: !!this.props.review,
                    showCancel: true,
                    confirmLabel: t("feedback", "report-review.send-button"),
                    title: t("feedback", "report-review.title"),
                    onCancel: function() {
                        return _this.close();
                    },
                    onConfirm: function() {
                        _this.sendReport({
                            review: _this.props.review,
                            message: _this.state.message,
                            email: email !== false ? email : _this.state.email
                        });
                    }
                }, /*#__PURE__*/ react.createElement(inputs/* TextArea */.Kx, {
                    onChange: function(e) {
                        return _this.setState({
                            message: e.target.value
                        });
                    },
                    name: "message",
                    label: t("feedback", "report-review.message-label"),
                    tabIndex: "0",
                    warning: !!errors.message,
                    helper: !errors.message ? t("feedback", "report-review.message-helper") : t("feedback", "error.field-is-required")
                }), !email && /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
                    onChange: function(e) {
                        return _this.setState({
                            email: e.target.value
                        });
                    },
                    name: "email",
                    label: t("feedback", "report-review.email-label"),
                    type: "email",
                    tabIndex: "0",
                    warning: !!errors.email,
                    helper: errors.email ? t("feedback", "error.field-is-required") : t("feedback", "report-review.email-helper")
                }));
            }
        }
    ]);
    return ReportReviewModal;
}(react.PureComponent);
ReportReviewModal.propTypes = {
    showModal: (prop_types_default()).func.isRequired,
    hideModal: (prop_types_default()).func.isRequired,
    reportReview: (prop_types_default()).func.isRequired,
    onComplete: (prop_types_default()).func.isRequired,
    account: prop_types_default().shape({
        me: (prop_types_default()).object
    }),
    review: prop_types_default().oneOfType([
        (prop_types_default()).object,
        (prop_types_default()).string
    ]),
    type: prop_types_default().oneOf([
        "product",
        "store"
    ]).isRequired
};
ReportReviewModal.defaultProps = {
    account: {
        me: undefined
    },
    review: undefined
};
ReportReviewModal.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const report = ((0,es/* connect */.$j)(function(state) {
    return {
        account: state.areas.account
    };
}, _objectSpread({}, actions/* default */.ZP, reviews_actions/* default */.ZP))(ReportReviewModal));


/***/ }),

/***/ 40617:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ prompt_prompt)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(25629);
// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./src/components/modal/index.tsx
var modal = __webpack_require__(68456);
// EXTERNAL MODULE: ./src/areas/account/components/submit-button/index.js
var submit_button = __webpack_require__(73711);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/areas/reviews/components/dialog/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 17px;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n          fill: ",
        ";\n        "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    svg {\n      margin-right: ",
        ";\n      height: 25px;\n\n      &,\n      path {\n        ",
        ";\n      }\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Form = styled_components_browser_esm["default"].form.withConfig({
    displayName: "Form",
    componentId: "sc-0-0"
})(_templateObject());
var Title = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var Error = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Error",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.negative;
});
var Section = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Section",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing200 */.bK.measurements.spacing200);
var InputTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "InputTitle",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Rating = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Rating",
    componentId: "sc-0-5"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, props.error && (0,styled_components_browser_esm.css)(_templateObject5(), props.theme.text.negative));
});
var Controls = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Controls",
    componentId: "sc-0-6"
})(_templateObject7());
var CancelButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CancelButton",
    componentId: "sc-0-7"
})(_templateObject8(), function(p) {
    return p.alignRight ? "auto" : 0;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var actions = __webpack_require__(93302);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
;// CONCATENATED MODULE: ./src/areas/reviews/components/dialog/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false; // Invalid format
    var d = new Date(dateString);
    if (!d.getTime() && d.getTime() !== 0) return false; // Invalid date
    return d.toISOString().slice(0, 10) === dateString;
}
var INITIAL_DRAFT = {
    belongsTo: null,
    rating: 0,
    text: ""
};
var selectOpenId = function(state) {
    return state.areas.review.dialog.openId;
};
var selectRequestError = function(state) {
    return state.areas.review.requestError;
};
var selectPendingRequest = function(state) {
    return state.areas.review.pendingRequest;
};
var selectSetDisplayName = function(state) {
    return state.areas.account.me ? !state.areas.account.me.displayName : null;
};
var UserReviewDialog = function(param) {
    var id = param.id, belongsTo = param.belongsTo, review = param.review;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, market = ref2.market;
    var formRef = (0,react.useRef)(null);
    var location = (0,react_router_dom/* useLocation */.TH)();
    var ref3 = _slicedToArray((0,react.useState)({}), 2), errors = ref3[0], setErrors = ref3[1];
    var ref4 = _slicedToArray((0,react.useState)(INITIAL_DRAFT), 2), reviewDraft = ref4[0], setReviewDraft = ref4[1];
    var openId = (0,es/* useSelector */.v9)(selectOpenId);
    var requestError = (0,es/* useSelector */.v9)(selectRequestError);
    var setDisplayName = (0,es/* useSelector */.v9)(selectSetDisplayName);
    var pendingRequest = (0,es/* useSelector */.v9)(selectPendingRequest);
    var type = belongsTo.type.toUpperCase();
    var saveReviewDraft = (0,react.useCallback)(function() {
        if (formRef.current) {
            var ref = form_serialize_default()(formRef.current, {
                hash: true
            }), reviewText = ref.reviewText, rating = ref.rating;
            setReviewDraft({
                belongsTo: belongsTo.id,
                text: reviewText,
                rating: rating ? parseInt(rating, 10) : 0
            });
        }
    }, [
        belongsTo.id
    ]);
    var handleClose = (0,react.useCallback)(function() {
        saveReviewDraft();
        dispatch((0,actions/* closeReviewDialog */.KW)());
    }, [
        dispatch,
        saveReviewDraft
    ]);
    var setPurchaseDate = market.modules && market.modules.userReviewPurchaseDate && market.modules.userReviewPurchaseDate.enabled && type === "PRODUCT";
    var validators = (0,react.useCallback)(function() {
        return {
            rating: function(rating) {
                return rating > 0 || t("reviews", "dialog.rating-required-error");
            },
            reviewText: function(reviewText) {
                return reviewText.trim().length > 0 || t("reviews", "dialog.text-required-error");
            },
            purchaseDate: function(purchaseDate) {
                if (!setPurchaseDate) {
                    return true;
                }
                return isValidDate(purchaseDate) || t("reviews", "dialog.date-invalid-error");
            },
            displayName: function(displayName) {
                return !setDisplayName ? true : displayName.trim().length > 0 || t("reviews", "dialog.name-required-error");
            }
        };
    }, [
        t,
        setDisplayName,
        setPurchaseDate
    ]);
    var validate = (0,react.useCallback)(function(data) {
        var fields = Object.keys(validators());
        var validateErrors = fields.reduce(function(err, key) {
            var valueToValidate = data[key];
            var response = validators()[key](valueToValidate);
            return response === true ? err : _objectSpreadProps(_objectSpread({}, err), _defineProperty({}, key, response));
        }, {});
        return {
            isValid: Object.keys(validateErrors).length === 0,
            validateErrors: validateErrors
        };
    }, [
        validators
    ]);
    var handleSubmit = (0,react.useCallback)(function(e, intent) {
        e.preventDefault();
        var ref = form_serialize_default()(e.target, {
            hash: true
        }), _reviewText = ref.reviewText, reviewText = _reviewText === void 0 ? "" : _reviewText, _rating = ref.rating, rating = _rating === void 0 ? 0 : _rating, _displayName = ref.displayName, displayName = _displayName === void 0 ? "" : _displayName, _purchaseDate = ref.purchaseDate, purchaseDate = _purchaseDate === void 0 ? "" : _purchaseDate;
        if (intent !== "delete") {
            var ref1 = validate({
                reviewText: reviewText,
                rating: rating,
                displayName: displayName,
                purchaseDate: purchaseDate
            }), isValid = ref1.isValid, validateErrors = ref1.validateErrors;
            if (!isValid) {
                setErrors(validateErrors);
                return;
            }
        }
        switch(intent){
            case "create":
                {
                    if (type === "PRODUCT") {
                        (0,tracking/* productReviewCreated */.ls)();
                        (0,tracking/* productRated */.dZ)(rating);
                    }
                    dispatch((0,actions/* createReview */.XU)({
                        rating: rating,
                        reviewText: reviewText,
                        displayName: displayName,
                        purchaseDate: undefined,
                        belongsToId: belongsTo.id,
                        reviewType: type
                    }));
                    break;
                }
            case "edit":
                {
                    if (!review) return;
                    if (type === "PRODUCT") {
                        (0,tracking/* productReviewEdited */.r)();
                    }
                    dispatch((0,actions/* editReview */.kP)({
                        rating: rating,
                        reviewText: reviewText,
                        purchaseDate: undefined,
                        reviewId: review.id,
                        reviewType: type,
                        belongsToId: belongsTo.id,
                        location: location.pathname
                    }));
                    break;
                }
            case "delete":
                {
                    if (!review) return;
                    if (type === "PRODUCT") {
                        (0,tracking/* productReviewDeleted */.fB)();
                    }
                    dispatch((0,actions/* deleteReview */.i0)({
                        reviewId: review.id,
                        reviewType: type,
                        belongsToId: belongsTo.id,
                        location: location.pathname
                    }));
                    break;
                }
            default:
                break;
        }
    }, [
        belongsTo.id,
        dispatch,
        location.pathname,
        review,
        type,
        validate
    ]);
    var handleCancel = (0,react.useCallback)(function(e) {
        e.preventDefault();
        handleClose();
    }, [
        handleClose
    ]);
    var clearErrors = (0,react.useCallback)(function(e) {
        var inputName = e.target.name;
        var remove = errors[inputName], errorsToKeep = _objectWithoutProperties(errors, [
            inputName
        ].map(_toPropertyKey));
        setErrors(errorsToKeep);
    }, [
        errors
    ]);
    var showSubmitSpinner = pendingRequest && (pendingRequest.type === "create" || pendingRequest.type === "edit");
    var showDeleteSpinner = pendingRequest && pendingRequest.type === "delete";
    var isOpen = openId === id;
    var ratingInput = reviewDraft.rating / 2;
    if (review && ratingInput === 0) {
        ratingInput = review.convertedRating || review.rating || 0;
    }
    return isOpen ? /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        className: "user-review-dialog",
        width: 500,
        onRequestClose: handleClose,
        isOpen: isOpen,
        key: "UserReviewDialogModal"
    }, /*#__PURE__*/ react.createElement(Form, {
        ref: formRef,
        onSubmit: function(e) {
            return handleSubmit(e, review ? "edit" : "create");
        },
        method: "POST"
    }, /*#__PURE__*/ react.createElement(Title, null, belongsTo.name), requestError && /*#__PURE__*/ react.createElement(Error, null, t("reviews", "dialog.unknown-error")), /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(InputTitle, null, t("reviews", "dialog.rate-info")), /*#__PURE__*/ react.createElement(Rating, {
        error: Boolean(errors.rating)
    }, /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        rate: ratingInput,
        interactive: true,
        onChange: function(_, e) {
            return clearErrors(e);
        }
    })), errors.rating && /*#__PURE__*/ react.createElement(Error, null, errors.rating)), /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(inputs/* TextArea */.Kx, {
        name: "reviewText",
        label: t("reviews", "dialog.text-area-label"),
        tabIndex: 0,
        helper: errors.reviewText || /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "reviews"
        }, "dialog.rules.md"),
        warning: Boolean(errors.reviewText),
        onChange: clearErrors,
        defaultValue: review ? review.reviewText : reviewDraft.text
    }), setPurchaseDate && /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(InputTitle, null, t("reviews", "dialog.purchase-date")), /*#__PURE__*/ react.createElement("input", {
        type: "date",
        name: "purchaseDate",
        placeholder: market === null || market === void 0 ? void 0 : (ref = market.modules) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewPurchaseDate) === null || ref1 === void 0 ? void 0 : ref1.datePlaceholderFormat,
        onChange: clearErrors,
        defaultValue: (review === null || review === void 0 ? void 0 : review.purchaseDate) || undefined
    }), errors.purchaseDate && /*#__PURE__*/ react.createElement(Error, null, errors.purchaseDate))), setDisplayName && /*#__PURE__*/ react.createElement(Section, null, /*#__PURE__*/ react.createElement(inputs/* TextInput */.oi, {
        name: "displayName",
        label: t("reviews", "dialog.display-name-label"),
        onChange: clearErrors,
        tabIndex: 0,
        helper: errors.displayName ? errors.displayName : t("reviews", "dialog.display-name-info"),
        warning: Boolean(errors.displayName),
        type: "text"
    })), /*#__PURE__*/ react.createElement(Controls, null, review && /*#__PURE__*/ react.createElement(submit_button/* default */.Z, {
        onClick: function(e) {
            return handleSubmit(e, "delete");
        },
        loading: showDeleteSpinner,
        text: t("reviews", "dialog.delete")
    }), /*#__PURE__*/ react.createElement(CancelButton, {
        onClick: handleCancel,
        color: "primary",
        variant: "outlined",
        alignRight: Boolean(review)
    }, t("reviews", "dialog.cancel")), /*#__PURE__*/ react.createElement(submit_button/* default */.Z, {
        loading: showSubmitSpinner,
        text: review ? t("reviews", "dialog.update") : t("reviews", "dialog.create")
    })))) : null;
};
/* harmony default export */ const dialog = (/*#__PURE__*/(0,react.memo)(UserReviewDialog));

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./src/components/review-form/components/multi-radio/index.tsx
var multi_radio = __webpack_require__(13673);
// EXTERNAL MODULE: ./src/components/review-form/components/form/index.tsx + 1 modules
var components_form = __webpack_require__(57515);
// EXTERNAL MODULE: ./src/components/review-form/components/text/index.tsx + 1 modules
var components_text = __webpack_require__(14521);
// EXTERNAL MODULE: ./src/components/review-form/components/title/index.tsx
var title = __webpack_require__(88920);
// EXTERNAL MODULE: ./src/components/review-form/components/info/index.tsx
var info = __webpack_require__(52396);
;// CONCATENATED MODULE: ./src/areas/reviews/components/store-form/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n from {\n    transform: translateY(100%);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n      max-height: ",
        ";\n      width: 100%;\n    "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: 0;\n    "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: row;\n    max-height: calc(0.95 * ",
        ");\n    margin: 0 auto;\n    overflow: auto;\n\n    ",
        ";\n\n    a {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n\n    ",
        ";\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n    top: ",
        ";\n    height: calc(100% - ",
        ");\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 100%;\n    transform: translate(0, 0);\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n  "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: fixed;\n  bottom: 0;\n  height: 95%;\n  margin: 0 auto;\n  padding: 0;\n  transform: translateY(0);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n\n  ",
        ";\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n      animation: ",
        " 300ms cubic-bezier(0.1, 0.74, 0.29, 1) 1;\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    ",
        "\n    animation: ",
        " 300ms cubic-bezier(0.1, 0.74, 0.29, 1) 1;\n\n    ",
        ";\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    padding: ",
        ";\n    padding-bottom: 0;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-bottom: 0;\n  flex-shrink: 0;\n\n  ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    height: calc(",
        " - ",
        ")\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    max-width: 680px;\n    margin: 0 auto;\n\n    ",
        ";\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background: ",
        ";\n  border-radius: 5px;\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n  max-width: 600px;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: normal;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  background: ",
        ";\n  padding: 10px;\n  border: 1px solid ",
        ";\n  outline: 0;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}





var desktopAnimation = (0,styled_components_browser_esm.keyframes)(styles_templateObject());
var mobileAnimation = (0,styled_components_browser_esm.keyframes)(styles_templateObject1());
var Content = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(styles_templateObject4(), p.height, base/* media.mediumDown */.BC.mediumDown(styles_templateObject2(), p.height), p.theme.text.callToAction, p.theme.text.callToActionHover, base/* media.mediumDown */.BC.mediumDown(styles_templateObject3()));
});
var modalReset = (0,styled_components_browser_esm.css)(styles_templateObject6(), base/* media.mediumDown */.BC.mediumDown(styles_templateObject5(), base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem, base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem));
var Modal = (0,styled_components_browser_esm["default"])(modal/* default */.Z).withConfig({
    displayName: "Modal",
    componentId: "sc-0-1"
})(styles_templateObject8(), modalReset, desktopAnimation, base/* media.mediumDown */.BC.mediumDown(styles_templateObject7(), mobileAnimation));
var PageTitle = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "PageTitle",
    componentId: "sc-0-2"
})(_templateObject9(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var styles_Form = (0,styled_components_browser_esm["default"])(components_form/* default */.Z).withConfig({
    displayName: "Form",
    componentId: "sc-0-3"
})(_templateObject11(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* media.mediumDown */.BC.mediumDown(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
var FormWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FormWrapper",
    componentId: "sc-0-4"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), base/* media.mediumDown */.BC.mediumDown(_templateObject12(), p.height, base/* layout.headerHeight.mobile.rem */.bK.headerHeight.mobile.rem));
});
var StoreCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreCard",
    componentId: "sc-0-5"
})(_templateObject14(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-6"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var Policy = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Policy",
    componentId: "sc-0-7"
})(_templateObject16(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var Optional = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Optional",
    componentId: "sc-0-8"
})(_templateObject17(), function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Link = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-9"
})(_templateObject18(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var PurchaseDateInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "PurchaseDateInput",
    componentId: "sc-0-10"
})(_templateObject19(), function(p) {
    return p.theme.inputs.primary.bg;
}, function(p) {
    return p.theme.inputs.primary.border;
});

// EXTERNAL MODULE: ./src/globals/api/requests.js
var requests = __webpack_require__(98129);
// EXTERNAL MODULE: ./src/areas/reviews/types.ts
var types = __webpack_require__(66122);
// EXTERNAL MODULE: ./src/areas/reviews/components/store-info-card/index.tsx + 1 modules
var store_info_card = __webpack_require__(81860);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./src/areas/reviews/hooks/use-review-error-toast.ts
var use_review_error_toast = __webpack_require__(81155);
// EXTERNAL MODULE: ./src/areas/store/constants.ts
var constants = __webpack_require__(26474);
// EXTERNAL MODULE: ./src/hooks/useEffectOnMount.ts
var useEffectOnMount = __webpack_require__(44388);
;// CONCATENATED MODULE: ./src/areas/reviews/components/store-form/index.tsx
function store_form_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function store_form_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function store_form_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function store_form_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function store_form_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function store_form_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = store_form_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function store_form_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function store_form_slicedToArray(arr, i) {
    return store_form_arrayWithHoles(arr) || store_form_iterableToArrayLimit(arr, i) || store_form_unsupportedIterableToArray(arr, i) || store_form_nonIterableRest();
}
function store_form_toPrimitive(input, hint) {
    if (store_form_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (store_form_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function store_form_toPropertyKey(arg) {
    var key = store_form_toPrimitive(arg, "string");
    return store_form_typeof(key) === "symbol" ? key : String(key);
}
var store_form_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function store_form_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return store_form_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return store_form_arrayLikeToArray(o, minLen);
}





















var FORM_ID = "shopReview";
var store_form_selectOpenId = function(state) {
    return state.areas.review.dialog.openId;
};
var selectPending = function(state) {
    return state.areas.review.pendingRequest;
};
var selectDisplayName = function(state) {
    return state.areas.account.me ? !state.areas.account.me.displayName : null;
};
var store_form_selectRequestError = function(state) {
    return state.areas.review.requestError;
};
var selectDrafts = function(state) {
    return state.areas.review.drafts;
};
var StoreReviewForm = function(param) {
    var uid = param.uid, store = param.store, review = param.review;
    var ref, ref1;
    var ref2 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref2.t, market = ref2.market, linkTo = ref2.linkTo;
    var dispatch = (0,es/* useDispatch */.I0)();
    var push = (0,react_router_dom/* useHistory */.k6)().push;
    var location = (0,react_router_dom/* useLocation */.TH)();
    var openId = (0,es/* useSelector */.v9)(store_form_selectOpenId);
    var pending = (0,es/* useSelector */.v9)(selectPending);
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var setDisplayName = (0,es/* useSelector */.v9)(selectDisplayName);
    var dispatchReviewErrorToast = (0,use_review_error_toast/* useReviewErrorToast */.O)();
    var requestError = (0,es/* useSelector */.v9)(store_form_selectRequestError);
    var drafts = (0,es/* useSelector */.v9)(selectDrafts);
    var ref3 = store_form_slicedToArray((0,react.useState)("100vh"), 2), viewportHeight = ref3[0], setViewportHeight = ref3[1];
    (0,react.useEffect)(function() {
        if (requestError) {
            dispatchReviewErrorToast(requestError);
        }
    }, [
        dispatchReviewErrorToast,
        requestError
    ]);
    var shouldSave = (0,react.useRef)(true);
    var shouldFetch = (0,react.useRef)(true);
    var ref4 = store_form_slicedToArray((0,react.useState)(review), 2), currentReview = ref4[0], setCurrentReview = ref4[1];
    var getActionType = (0,react.useCallback)(function() {
        if (review) {
            return components_form/* ActionType.EDIT */.U.EDIT;
        }
        if (isAuthenticated) {
            return components_form/* ActionType.PUBLISH */.U.PUBLISH;
        }
        return components_form/* ActionType.CREATE */.U.CREATE;
    }, [
        isAuthenticated,
        review
    ]);
    var isEdit = getActionType() === components_form/* ActionType.EDIT */.U.EDIT;
    var setPurchaseDate = Boolean((ref = market.modules) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewPurchaseDate) === null || ref1 === void 0 ? void 0 : ref1.enabled);
    var redirectToShop = (0,react.useCallback)(function(query) {
        push(linkTo("store", {
            id: store.id,
            pathName: store.pathName
        }, query));
    }, [
        linkTo,
        push,
        store.id,
        store.pathName
    ]);
    (0,react.useEffect)(function() {
        // In case the initial render is missing `review`, we update the state when it appears
        // For example when a user lands on then `?review=write` page but already has a review
        // the prop `review` will be missing but added on a re-render.
        if (review && shouldFetch.current) setCurrentReview(review);
    }, [
        review
    ]);
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        // Fetch all custom questions and answers for a review on mount
        // or when `actionType` changes
        if (isEdit && shouldFetch.current) {
            var reviewId = review === null || review === void 0 ? void 0 : review.id;
            (0,requests/* fetchShopReview */.TL)(reviewId).then(function(response) {
                var ref, ref1;
                if (((ref = response.errors) === null || ref === void 0 ? void 0 : ref.length) > 0 && !currentReview) {
                    handleClose();
                    redirectToShop({
                        notification: "error"
                    });
                }
                if (response.data && !((ref1 = response.errors) === null || ref1 === void 0 ? void 0 : ref1.length)) {
                    setCurrentReview(response.data.shopReview);
                }
                shouldFetch.current = false;
            });
        }
    });
    (0,useEffectOnMount/* useEffectOnMount */.O)(function() {
        // Fill form using saved draft data if it exists.
        if (review === null || review === void 0 ? void 0 : review.id) {
            if (drafts && drafts[review.id]) {
                // @ts-expect-error -- unsure why it's complaining
                setCurrentReview(mapQuestionsToReview(drafts[review.id]));
            }
        } else if (drafts && drafts[store.id]) {
            // @ts-expect-error -- unsure why it's complaining
            setCurrentReview(mapQuestionsToReview(drafts[store.id]));
        }
        return function() {
            // Prevents `saveDraft` from saving empty value if form is closed before save occurs.
            shouldSave.current = false;
        };
    });
    (0,react.useEffect)(function() {
        var updateViewportHeight = function() {
            if (false) {}
            // On mobile `vh` does not take browser UI into consideration,
            // causing 100vh to be higher than what is visible.
            // `window.innerHeight` is the actual visible height of the window
            // and will be updated every render.
            setViewportHeight("".concat(window.innerHeight, "px"));
        };
        window.addEventListener("resize", updateViewportHeight);
        updateViewportHeight();
        return function() {
            return window.removeEventListener("resize", updateViewportHeight);
        };
    }, [
        setViewportHeight
    ]);
    (0,react.useEffect)(function() {
        (0,tracking/* trackStoreReviewFormViewed */.uy)({
            type: tracking/* ShopReviewType.SHOP */.zv.SHOP,
            storeId: store.id,
            storeName: store.name
        });
    });
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,actions/* closeReviewDialog */.KW)());
    }, [
        dispatch
    ]);
    var mapQuestionsToReview = function(questions) {
        var _Rating = types/* Questions.Rating */.Gw.Rating, _Review = types/* Questions.Review */.Gw.Review, _Email = types/* Questions.Email */.Gw.Email, _DisplayName = types/* Questions.DisplayName */.Gw.DisplayName, _PurchaseDate = types/* Questions.PurchaseDate */.Gw.PurchaseDate, rating = questions[_Rating], reviewText = questions[_Review], email = questions[_Email], displayName = questions[_DisplayName], purchaseDate = questions[_PurchaseDate], customQuestions = store_form_objectWithoutProperties(questions, [
            _Rating,
            _Review,
            _Email,
            _DisplayName,
            _PurchaseDate
        ].map(store_form_toPropertyKey));
        var scaledRating;
        if (rating) scaledRating = Number(rating) * 2;
        var answers = Object.keys(customQuestions).map(function(question) {
            return {
                id: question,
                answer: Number(customQuestions[question])
            };
        });
        return {
            rating: scaledRating,
            reviewText: reviewText,
            email: email,
            displayName: displayName,
            purchaseDate: purchaseDate,
            answers: answers
        };
    };
    var handleSubmit = (0,react.useCallback)(function(formData) {
        var ref = mapQuestionsToReview(formData), rating = ref.rating, reviewText = ref.reviewText, email = ref.email, displayName = ref.displayName, purchaseDate = ref.purchaseDate, answers = ref.answers;
        switch(getActionType()){
            case components_form/* ActionType.PUBLISH */.U.PUBLISH:
            case components_form/* ActionType.CREATE */.U.CREATE:
                {
                    dispatch((0,actions/* createShopReview */.rj)({
                        belongsToId: store.id,
                        belongsToName: store.name,
                        rating: rating,
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers,
                        email: email,
                        displayName: displayName
                    }));
                    break;
                }
            case components_form/* ActionType.EDIT */.U.EDIT:
                {
                    dispatch((0,actions/* editShopReview */.ID)({
                        belongsToId: store.id,
                        belongsToName: store.name,
                        reviewId: currentReview === null || currentReview === void 0 ? void 0 : currentReview.id,
                        rating: rating,
                        reviewText: reviewText,
                        purchaseDate: purchaseDate,
                        answers: answers,
                        token: review === null || review === void 0 ? void 0 : review.code,
                        location: location.pathname
                    }));
                    break;
                }
            default:
        }
    }, [
        getActionType,
        dispatch,
        store.id,
        store.name,
        currentReview,
        review,
        location.pathname
    ]);
    var handleDelete = (0,react.useCallback)(function() {
        dispatch((0,actions/* deleteShopReview */.Yf)({
            reviewId: currentReview === null || currentReview === void 0 ? void 0 : currentReview.id,
            token: review === null || review === void 0 ? void 0 : review.code,
            shopId: store.id,
            shopName: store.name,
            location: location.pathname
        }));
    }, [
        dispatch,
        currentReview,
        review,
        store.id,
        store.name,
        location.pathname
    ]);
    var saveDraft = (0,react.useCallback)(debounce_default()(function(formData) {
        if (shouldSave.current) {
            if (getActionType() === components_form/* ActionType.PUBLISH */.U.PUBLISH || getActionType() === components_form/* ActionType.CREATE */.U.CREATE) {
                dispatch((0,actions/* saveReviewDraft */.YM)(store_form_defineProperty({}, store.id, formData)));
            } else if (review === null || review === void 0 ? void 0 : review.id) {
                dispatch((0,actions/* saveReviewDraft */.YM)(store_form_defineProperty({}, review.id, formData)));
            }
        }
    }, 300), [
        dispatch,
        store.id
    ]);
    var questions = [
        {
            id: types/* Questions.DisplayName */.Gw.DisplayName
        },
        {
            id: types/* Questions.Rating */.Gw.Rating
        },
        {
            id: types/* Questions.Review */.Gw.Review
        },
        {
            id: types/* Questions.PaidReview */.Gw.PaidReview
        },
        {
            id: types/* Questions.Email */.Gw.Email
        }
    ];
    return /*#__PURE__*/ react.createElement(Modal, {
        width: undefined,
        onRequestClose: handleClose,
        isOpen: openId === uid,
        key: "StoreReviewForm",
        dataTest: "StoreReviewForm"
    }, /*#__PURE__*/ react.createElement(Content, {
        height: viewportHeight
    }, /*#__PURE__*/ react.createElement(FormWrapper, {
        height: viewportHeight
    }, /*#__PURE__*/ react.createElement(styles_Form, {
        id: FORM_ID,
        onSubmit: handleSubmit,
        onCancel: handleClose,
        onDelete: isEdit ? handleDelete : undefined,
        pending: pending,
        actionType: getActionType(),
        onChange: saveDraft
    }, /*#__PURE__*/ react.createElement(PageTitle, null, t("reviews", "store.form-title")), store ? /*#__PURE__*/ react.createElement(store_info_card/* default */.Z, {
        storeId: store.id,
        storeName: store.name,
        featured: store.featured,
        hasLogo: store.hasLogo,
        reviewCount: store.userReviewSummary.countTotal,
        logoUrl: store.logo,
        logoWidth: constants/* SHOP_LOGO_WIDTH */.L9
    }) : null, market.shopOfTheYear && /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "reviews"
    }, "store.soty-info.md"), questions.map(function(question) {
        var ref, ref1;
        var answer = currentReview === null || currentReview === void 0 ? void 0 : (ref = currentReview.answers) === null || ref === void 0 ? void 0 : ref.find(function(a) {
            return a && a.id === question.id;
        });
        var showQuestion = currentReview === null || currentReview === void 0 ? void 0 : (ref1 = currentReview.answers) === null || ref1 === void 0 ? void 0 : ref1.length;
        switch(question.id){
            case types/* Questions.Rating */.Gw.Rating:
                {
                    if (isEdit && !(currentReview === null || currentReview === void 0 ? void 0 : currentReview.rating)) return null;
                    return /*#__PURE__*/ react.createElement("div", {
                        key: question.id
                    }, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "store.question-rating")), /*#__PURE__*/ react.createElement(multi_radio/* default */.ZP, {
                        name: types/* Questions.Rating */.Gw.Rating,
                        variant: multi_radio/* Variants.rate */.tr.rate,
                        options: [
                            1,
                            2,
                            3,
                            4,
                            5
                        ],
                        optionValues: [
                            t("reviews", "rating.terrible"),
                            t("reviews", "rating.bad"),
                            t("reviews", "rating.ok"),
                            t("reviews", "rating.good"),
                            t("reviews", "rating.excellent")
                        ],
                        required: true,
                        currentValue: currentReview === null || currentReview === void 0 ? void 0 : currentReview.rating
                    }));
                }
            case types/* Questions.Review */.Gw.Review:
                {
                    return /*#__PURE__*/ react.createElement("div", {
                        key: question.id
                    }, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "store.question-review")), /*#__PURE__*/ react.createElement(components_text/* default */.Z, {
                        type: components_text/* TextTypes.TextArea */.a.TextArea,
                        name: types/* Questions.Review */.Gw.Review,
                        placeholder: t("reviews", "store.question-review-placeholder"),
                        defaultValue: currentReview === null || currentReview === void 0 ? void 0 : currentReview.reviewText,
                        minLength: 20,
                        required: true
                    }), /*#__PURE__*/ react.createElement(info/* default */.Z, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "reviews"
                    }, "dialog.rules.md")));
                }
            case types/* Questions.PaidReview */.Gw.PaidReview:
                {
                    if (isEdit && !showQuestion) return null;
                    return /*#__PURE__*/ react.createElement("div", {
                        key: question.id
                    }, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "store.question-sponsored")), /*#__PURE__*/ react.createElement(info/* default */.Z, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
                        domain: "reviews"
                    }, "store.question-sponsored-info.md")), /*#__PURE__*/ react.createElement(multi_radio/* default */.ZP, {
                        name: types/* Questions.PaidReview */.Gw.PaidReview,
                        variant: multi_radio/* Variants.boolean */.tr.boolean,
                        options: [
                            0,
                            1
                        ],
                        required: true,
                        currentValue: answer === null || answer === void 0 ? void 0 : answer.answer
                    }));
                }
            case types/* Questions.PurchaseDate */.Gw.PurchaseDate:
                {
                    var ref2, ref3;
                    if (!setPurchaseDate) return null;
                    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "dialog.purchase-date")), /*#__PURE__*/ react.createElement(PurchaseDateInput, {
                        type: "date",
                        name: "purchaseDate",
                        placeholder: market === null || market === void 0 ? void 0 : (ref2 = market.modules) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.userReviewPurchaseDate) === null || ref3 === void 0 ? void 0 : ref3.datePlaceholderFormat,
                        defaultValue: (currentReview === null || currentReview === void 0 ? void 0 : currentReview.purchaseDate) || undefined
                    }));
                }
            case types/* Questions.Email */.Gw.Email:
                {
                    if (isEdit || isAuthenticated) return null;
                    return /*#__PURE__*/ react.createElement("div", {
                        key: question.id
                    }, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "dialog.email-label")), /*#__PURE__*/ react.createElement(components_text/* default */.Z, {
                        name: types/* Questions.Email */.Gw.Email,
                        type: components_text/* TextTypes.Email */.a.Email,
                        placeholder: "Email",
                        required: true
                    }), /*#__PURE__*/ react.createElement(info/* default */.Z, null, t("reviews", "form.email-usage-policy")), /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "form.user-login-promo"), " ", /*#__PURE__*/ react.createElement(Link, {
                        to: "/login"
                    }, t("account", "sign-in-promo.sign-in-button")), " ", t("reviews", "form.user-login-promo-connect")));
                }
            case types/* Questions.DisplayName */.Gw.DisplayName:
                {
                    if (!setDisplayName) return null;
                    return /*#__PURE__*/ react.createElement("div", {
                        key: question.id
                    }, /*#__PURE__*/ react.createElement(title/* default */.Z, null, t("reviews", "dialog.display-name-info")), /*#__PURE__*/ react.createElement(components_text/* default */.Z, {
                        name: types/* Questions.DisplayName */.Gw.DisplayName,
                        type: components_text/* TextTypes.Text */.a.Text,
                        placeholder: t("reviews", "dialog.display-name-label"),
                        required: true
                    }));
                }
            default:
                return null;
        }
    })))));
};
/* harmony default export */ const store_form = (/*#__PURE__*/(0,react.memo)(StoreReviewForm));

// EXTERNAL MODULE: ./src/areas/reviews/components/thank-you/styles.ts
var styles = __webpack_require__(86363);
// EXTERNAL MODULE: ./src/areas/reviews/components/thank-you/shop-review-thank-you.tsx
var shop_review_thank_you = __webpack_require__(68315);
;// CONCATENATED MODULE: ./src/areas/reviews/components/thank-you/index.tsx







var thank_you_selectOpenId = function(state) {
    return state.areas.review.thankYouDialog.openId;
};
var ThankYouModal = function(param) {
    var uid = param.uid;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, market = ref.market;
    var dispatch = (0,es/* useDispatch */.I0)();
    var openId = (0,es/* useSelector */.v9)(thank_you_selectOpenId);
    var handleClose = (0,react.useCallback)(function() {
        dispatch((0,actions/* hideShopReviewThankYouDialog */.g0)());
    }, []);
    return market.shopOfTheYear ? /*#__PURE__*/ react.createElement(modal/* default */.Z, {
        isOpen: openId === uid,
        onRequestClose: handleClose,
        width: 600
    }, /*#__PURE__*/ react.createElement(styles/* Content */.VY, null, /*#__PURE__*/ react.createElement(shop_review_thank_you/* default */.Z, null), /*#__PURE__*/ react.createElement(styles/* CloseButton */.PZ, {
        size: "small",
        color: "primary",
        onClick: handleClose
    }, t("symbols", "symbol.close")))) : null;
};
/* harmony default export */ const thank_you = (ThankYouModal);

;// CONCATENATED MODULE: ./src/areas/reviews/components/prompt/styles.ts
function prompt_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function prompt_styles_templateObject() {
    var data = prompt_styles_taggedTemplateLiteral([
        "\n  display: inline-block;\n  max-width: 270px;\n  align-self: center;\n"
    ]);
    prompt_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function prompt_styles_templateObject1() {
    var data = prompt_styles_taggedTemplateLiteral([
        ""
    ]);
    prompt_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

var UserReviewPrompt = styled_components_browser_esm["default"].div.withConfig({
    displayName: "UserReviewPrompt",
    componentId: "sc-0-0"
})(prompt_styles_templateObject());
var FirstToReview = styled_components_browser_esm["default"].p.withConfig({
    displayName: "FirstToReview",
    componentId: "sc-0-1"
})(prompt_styles_templateObject1());

;// CONCATENATED MODULE: ./src/areas/reviews/components/prompt/prompt.tsx
function prompt_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function prompt_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function prompt_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function prompt_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function prompt_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function prompt_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            prompt_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function prompt_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function prompt_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        prompt_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function prompt_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = prompt_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function prompt_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function prompt_slicedToArray(arr, i) {
    return prompt_arrayWithHoles(arr) || prompt_iterableToArrayLimit(arr, i) || prompt_unsupportedIterableToArray(arr, i) || prompt_nonIterableRest();
}
function prompt_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return prompt_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return prompt_arrayLikeToArray(o, minLen);
}












var selectReviewDialogOpenId = function(state) {
    return state.areas.review.dialog.openId;
};
var selectThankYouDialogOpenId = function(state) {
    return state.areas.review.thankYouDialog.openId;
};
var ReviewPrompt = function(param) {
    var className = param.className, control = param.control, belongsTo = param.belongsTo, currentReview = param.currentReview, store = param.store;
    var ref = prompt_slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref[0], setShowLoginPromo = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react_router_dom/* useLocation */.TH)(), pathname = ref1.pathname, search = ref1.search;
    var push = (0,react_router_dom/* useHistory */.k6)().push;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var reviewDialogOpenId = (0,es/* useSelector */.v9)(selectReviewDialogOpenId);
    var thankYouDialogOpenId = (0,es/* useSelector */.v9)(selectThankYouDialogOpenId);
    var uid = (0,react.useId)();
    var _ref = dist_default().parse(search), reviewParam = _ref.review, anonReviewId = _ref.review_id, code = _ref.code, queryParams = prompt_objectWithoutProperties(_ref, [
        "review",
        "review_id",
        "code"
    ]);
    var isStorePage = /((butiksinfo|store|shop).php)|(--s\d)/.test(pathname);
    var actionType = currentReview || code && anonReviewId ? types/* Action.EDIT */.aU.EDIT : types/* Action.WRITE */.aU.WRITE;
    var clickHandler = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        if (belongsTo.type === "product" && !isAuthenticated) {
            setShowLoginPromo(true);
        } else {
            dispatch((0,actions/* openReviewDialog */.H1)(uid));
            if (belongsTo.type === "store" && isStorePage) {
                if (actionType === types/* Action.WRITE */.aU.WRITE) {
                    push(decodeURIComponent("".concat(pathname, "?").concat(dist_default().stringify(prompt_objectSpreadProps(prompt_objectSpread({}, queryParams), {
                        review: types/* Action.WRITE */.aU.WRITE
                    })))));
                } else {
                    push(decodeURIComponent("".concat(pathname, "?").concat(dist_default().stringify(prompt_objectSpreadProps(prompt_objectSpread({}, queryParams), {
                        review: types/* Action.EDIT */.aU.EDIT
                    })))));
                }
            }
        }
    }, [
        isAuthenticated,
        dispatch,
        uid,
        belongsTo.type,
        pathname,
        queryParams,
        push,
        isStorePage,
        actionType
    ]);
    var closeLoginPromo = (0,react.useCallback)(function() {
        setShowLoginPromo(false);
    }, []);
    var shouldOpenWriteReview = reviewParam === types/* Action.WRITE */.aU.WRITE && actionType === types/* Action.WRITE */.aU.WRITE;
    var shouldOpenEditReview = actionType === types/* Action.EDIT */.aU.EDIT && reviewParam === types/* Action.EDIT */.aU.EDIT;
    (0,react.useEffect)(function() {
        if (!isStorePage) return;
        // Open the review form dialog when landing on a page with the query param `review`
        if (shouldOpenWriteReview || shouldOpenEditReview) {
            if (!reviewDialogOpenId) {
                dispatch((0,actions/* openReviewDialog */.H1)(uid));
            }
        }
        // Close review form when query param `review` is removed
        if (!shouldOpenWriteReview && !shouldOpenEditReview && reviewDialogOpenId === uid) {
            dispatch((0,actions/* closeReviewDialog */.KW)());
        }
    }, [
        reviewParam
    ]);
    var anonymousReview = code && anonReviewId ? {
        id: anonReviewId,
        code: code
    } : undefined;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, belongsTo.type === "product" && /*#__PURE__*/ react.createElement(dialog, {
        id: uid,
        belongsTo: belongsTo,
        review: currentReview
    }), belongsTo.type === "store" && store && reviewDialogOpenId === uid && /*#__PURE__*/ react.createElement(store_form, {
        uid: uid,
        store: store,
        review: currentReview || anonymousReview
    }), belongsTo.type === "store" && thankYouDialogOpenId === uid && /*#__PURE__*/ react.createElement(thank_you, {
        uid: uid
    }), /*#__PURE__*/ react.createElement(UserReviewPrompt, {
        className: className
    }, !isAuthenticated && showLoginPromo ? /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: showLoginPromo,
        onRequestClose: closeLoginPromo
    }) : null, /*#__PURE__*/ react.cloneElement(control, {
        onClick: clickHandler
    })));
};
/* harmony default export */ const prompt_prompt = (/*#__PURE__*/(0,react.memo)(ReviewPrompt));


/***/ }),

/***/ 81860:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ store_info_card)
});

// UNUSED EXPORTS: StoreInfoCard

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(90243);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/reviews/components/store-info-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background: ",
        ";\n  border-radius: 5px;\n  padding: ",
        ";\n  margin-bottom: ",
        ";\n  max-width: 600px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StoreCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreCard",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StoreInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StoreInfo",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);

;// CONCATENATED MODULE: ./src/areas/reviews/components/store-info-card/index.tsx




var StoreInfoCard = function(param) {
    var featured = param.featured, hasLogo = param.hasLogo, reviewCount = param.reviewCount, storeId = param.storeId, storeName = param.storeName, logoUrl = param.logoUrl, _logoWidth = param.logoWidth, logoWidth = _logoWidth === void 0 ? 88 : _logoWidth;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var highResolutionLogo = logoUrl ? {
        url: logoUrl,
        width: logoWidth
    } : null;
    var displayReviewCount = reviewCount && reviewCount > 500 ? "500+" : reviewCount || 0;
    return /*#__PURE__*/ react.createElement(StoreCard, null, featured && hasLogo && storeId && /*#__PURE__*/ react.createElement(store_logo/* StoreLogo */.Xv, {
        name: storeName,
        storeId: storeId,
        featured: featured,
        hasImage: hasLogo,
        variant: store_logo/* StoreLogoVariant.REVIEWS */.mA.REVIEWS,
        logoUrl: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.url,
        width: highResolutionLogo === null || highResolutionLogo === void 0 ? void 0 : highResolutionLogo.width,
        showHighResolutionLogo: Boolean(highResolutionLogo)
    }), /*#__PURE__*/ react.createElement(StoreInfo, null, /*#__PURE__*/ react.createElement("div", null, storeName), /*#__PURE__*/ react.createElement("div", null, t("reviews", "user.total-reviews", {
        n: displayReviewCount
    }))));
};
/* harmony default export */ const store_info_card = (StoreInfoCard);


/***/ }),

/***/ 68315:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
/* harmony import */ var src_components_translate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88557);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86363);
/* harmony import */ var _hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96328);
/* harmony import */ var _prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27408);
/* harmony import */ var _prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5521);
/* harmony import */ var _prisjakt_ui_icon_notification_filled__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28529);








var YEAR = new Date().getFullYear();
var ShopReviewThankYou = function(param) {
    var style = param.style, className = param.className;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), market = ref.market, t = ref.t, linkTo = ref.linkTo;
    var isAuthenticated = (0,_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_4__/* .useIsAuthenticated */ .k)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
        style: style,
        className: className
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .Dx, null, isAuthenticated ? t("reviews", "store.completed-title") : t("reviews", "store.completed-title-not-logged-in")), !isAuthenticated && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, t("reviews", "store.completed-awaiting-verification")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_2__/* .Translate */ .v, {
        domain: "reviews"
    }, "store.verification-email.md"))), market.shopOfTheYear && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Soty */ .fk, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
        src: "".concat(market.cdn, "/g/store_of_the_year/generic_badges/").concat(market.code, "/soty_generic.png"),
        alt: t("campaigns", "shop-of-the-year.title-with-year", {
            year: YEAR
        }),
        width: 100
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_translate__WEBPACK_IMPORTED_MODULE_2__/* .Translate */ .v, {
        domain: "reviews"
    }, "store.soty-info.md")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
        to: linkTo("shopOfTheYear")
    }, t("reviews", "store.completed-soty-link"))), isAuthenticated ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .Dx, null, t("reviews", "store.completed-profile-title")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, t("reviews", "store.completed-profile-text")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_6__/* .IconLikeFilled */ .G, {
        size: 20,
        color: "maybeBlue700"
    }), t("reviews", "store.completed-profile-helpful")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
        to: "/account/profile"
    }, t("reviews", "store.completed-profile-link"))) : /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Title */ .Dx, null, t("reviews", "store.completed-create-account")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_notification_filled__WEBPACK_IMPORTED_MODULE_7__/* .IconNotificationFilled */ .Q, {
        size: 20,
        color: "maybeBlue700"
    }), t("reviews", "store.completed-alerts")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_heart_filled__WEBPACK_IMPORTED_MODULE_5__/* .IconHeartFilled */ .g, {
        size: 20,
        color: "maybeBlue700"
    }), t("reviews", "store.completed-lists")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_6__/* .IconLikeFilled */ .G, {
        size: 20,
        color: "maybeBlue700"
    }), t("reviews", "store.completed-helpful-profile")), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU, {
        to: "/signup"
    }, t("account", "sign-in-promo.create-account-button"))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ShopReviewThankYou);


/***/ }),

/***/ 86363:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "PZ": () => (/* binding */ CloseButton),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "fk": () => (/* binding */ Soty),
/* harmony export */   "rU": () => (/* binding */ Link),
/* harmony export */   "xv": () => (/* binding */ Text)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33999);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51322);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  padding-top: ",
        ";\n  padding-left: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: normal;\n  margin-bottom: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 600;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n    color: ",
        ";\n  }\n\n  a {\n    color: ",
        ";\n    font-weight: 600;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto 1fr;\n  grid-gap: ",
        ";\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n\n  ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n  }\n\n  ",
        " {\n    grid-area: 1 / 2 / 2 / 3;\n  }\n\n  ",
        " {\n    grid-area: 2 / 2 / 3 / 3;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: 50%;\n  margin-left: auto;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}




var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h3.withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150);
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "Image",
    componentId: "sc-0-2"
})(_templateObject2());
var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .rU).withConfig({
    displayName: "Link",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-4"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.icons.callToAction;
}, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Soty = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Soty",
    componentId: "sc-0-5"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, Image, Text, Link);
var CloseButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_button__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-6"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);


/***/ }),

/***/ 81155:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ useReviewErrorToast)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3732);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66431);
/* harmony import */ var _components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64076);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66122);





function useReviewErrorToast() {
    var dispatchReviewErrorToast = function dispatchReviewErrorToast(errorCode) {
        if (!errorCode) return;
        switch(errorCode){
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.USER_ALREADY_HAS_REVIEW */ .D1.USER_ALREADY_HAS_REVIEW:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "error.user-already-has-review")));
                break;
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.USER_CONNECTED_TO_STORE */ .D1.USER_CONNECTED_TO_STORE:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "error.user-connected-to-store")));
                break;
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.USER_HOURLY_LIMIT_REACHED_SHOP */ .D1.USER_HOURLY_LIMIT_REACHED_SHOP:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "error.user-hourly-limit-reached-shop")));
                break;
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.USER_HOURLY_LIMIT_REACHED_ALL_SHOPS */ .D1.USER_HOURLY_LIMIT_REACHED_ALL_SHOPS:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "error.user-hourly-limit-reached-all-shops")));
                break;
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.UNDER_INVESTIGATION */ .D1.UNDER_INVESTIGATION:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "error.under-investigation")));
                break;
            case _types__WEBPACK_IMPORTED_MODULE_4__/* .Errors.INVALID_PARAMETER */ .D1.INVALID_PARAMETER:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "dialog.unknown-error")));
                break;
            default:
                dispatch((0,_components_toast_container_actions__WEBPACK_IMPORTED_MODULE_3__/* .promptToast */ .Lf)("error", t("reviews", "dialog.unknown-error")));
                break;
        }
    };
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il).t;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    return dispatchReviewErrorToast;
}


/***/ }),

/***/ 56132:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": () => (/* binding */ useReviewContext),
/* harmony export */   "b": () => (/* binding */ ReviewContextContainer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

var initialValue = {
    onReviewExpansion: undefined
};
var ReviewContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useReviewContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReviewContext);
};
var ReviewContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ReviewContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 66122:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D1": () => (/* binding */ Errors),
/* harmony export */   "Gw": () => (/* binding */ Questions),
/* harmony export */   "aU": () => (/* binding */ Action)
/* harmony export */ });
var Action;
(function(Action) {
    Action["WRITE"] = "write";
    Action["EDIT"] = "edit";
})(Action || (Action = {}));
var Questions;
(function(Questions) {
    Questions["Rating"] = "store.rating";
    Questions["Review"] = "store.review";
    Questions["Recommend"] = "store.recommend";
    Questions["DeliveryAccuracy"] = "store.delivery_accuracy";
    Questions["CustomerService"] = "store.customer_service";
    Questions["PaidReview"] = "store.paid_review";
    Questions["Email"] = "email";
    Questions["DisplayName"] = "displayname";
    Questions["PurchaseDate"] = "purchaseDate";
})(Questions || (Questions = {}));
var Errors;
(function(Errors) {
    Errors["USER_ALREADY_HAS_REVIEW"] = "user_review.already_exists";
    Errors["USER_CONNECTED_TO_STORE"] = "user_review.account_connected_to_store";
    Errors["USER_HOURLY_LIMIT_REACHED_SHOP"] = "user_review.hourly_limit_reached_shop";
    Errors["USER_HOURLY_LIMIT_REACHED_ALL_SHOPS"] = "user_review.hourly_limit_reached_all_shops";
    Errors["UNDER_INVESTIGATION"] = "user_review.under_investigation";
    Errors["INVALID_PARAMETER"] = "request.invalid-parameter";
    Errors["UNKNOWN_ERROR"] = "dialog.unknown-error";
})(Errors || (Errors = {}));


/***/ }),

/***/ 35636:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ reviews)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/areas/reviews/components/report/index.js + 2 modules
var report = __webpack_require__(62539);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(25629);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
// EXTERNAL MODULE: ./src/areas/reviews/actions/index.js
var actions = __webpack_require__(93302);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/styles.ts
var styles = __webpack_require__(28127);
;// CONCATENATED MODULE: ./src/areas/reviews/user-reviews/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        ",
        " ",
        " {\n          display: none;\n        }\n\n        display: grid;\n        column-gap: ",
        ";\n        grid-template-columns: repeat(3, 22rem);\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        grid-template-columns: repeat(3, 84vw);\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var ReviewList = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "ReviewList",
    componentId: "sc-0-0"
})(_templateObject3(), function(p) {
    return p.$collapsed && (0,styled_components_browser_esm.css)(_templateObject2(), base/* media.mediumDown */.BC.mediumDown(_templateObject(), styles/* UserReviewCard */.IR, styles/* ReportButton */.f4, base/* layout.measurements.spacing100 */.bK.measurements.spacing100), base/* media.smallOnly */.BC.smallOnly(_templateObject1()));
});

// EXTERNAL MODULE: ./src/components/user-review-card-v2/product.tsx + 2 modules
var product = __webpack_require__(80574);
// EXTERNAL MODULE: ./src/components/horizontal-scroll/index.tsx + 1 modules
var horizontal_scroll = __webpack_require__(86898);
;// CONCATENATED MODULE: ./src/areas/reviews/user-reviews/reviews.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var UserReviews = function(param) {
    var user = param.user, userReviews = param.userReviews, pageInfo = param.pageInfo, belongsTo = param.belongsTo, reviewSource = param.reviewSource, showAll = param.showAll;
    var ref = _slicedToArray((0,react.useState)(null), 2), reportReview = ref[0], setReportReview = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref1[0], setShowLoginPromo = ref1[1];
    var containerElement = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        // Track reviews listed
        if (belongsTo.type === "product") {
            if (reviewSource === "users") {
                var ref;
                (0,tracking/* productReviewsListed */.Lm)(pageInfo === null || pageInfo === void 0 ? void 0 : (ref = pageInfo.sort) === null || ref === void 0 ? void 0 : ref.name, {
                    offset: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.offset
                });
            }
        }
    }, [
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.offset,
        pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.sort,
        belongsTo.type,
        reviewSource
    ]);
    var onCompleteReport = (0,react.useCallback)(function() {
        setReportReview(null);
    }, []);
    var hideLoginPromo = (0,react.useCallback)(function() {
        setShowLoginPromo(false);
    }, []);
    var renderReview = (0,react.useCallback)(function(review) {
        var ref, ref1;
        if (review.underInvestigation || !belongsTo || !review.id) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(product/* default */.Z, {
            key: review.id,
            id: review.id,
            text: review.reviewText,
            rating: review.convertedRating,
            purchaseDate: review.purchaseDate,
            translation: review.translation,
            createdAt: review.createdAt,
            updatedAt: review.updatedAt,
            createdAtFromNow: review.createdAtFromNow,
            updatedAtFromNow: review.updatedAtFromNow,
            userId: review.user && review.user.id,
            userAvatar: review.user && review.user.avatar,
            userDisplayName: review.user && review.user.displayName,
            userReviewCount: review.user && review.user.reviewCount,
            belongsTo: belongsTo,
            isMyReview: Boolean(user && review.user && user.id === review.user.id),
            likes: review.likeScore,
            unregisteredUser: (ref = review.user) === null || ref === void 0 ? void 0 : ref.unregistered,
            isFakeAccount: (ref1 = review.user) === null || ref1 === void 0 ? void 0 : ref1.isFakeAccount,
            expanded: showAll
        });
    }, [
        belongsTo,
        user
    ]);
    var renderedUserReviews = (0,react.useMemo)(function() {
        return userReviews === null || userReviews === void 0 ? void 0 : userReviews.map(renderReview);
    }, [
        userReviews,
        renderReview
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        ref: containerElement
    }, /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: showLoginPromo,
        onRequestClose: hideLoginPromo
    }), /*#__PURE__*/ react.createElement(report/* default */.Z, {
        review: reportReview,
        onComplete: onCompleteReport,
        type: belongsTo.type
    }), /*#__PURE__*/ react.createElement(horizontal_scroll/* default */.C, null, /*#__PURE__*/ react.createElement(ReviewList, {
        $collapsed: !showAll
    }, renderedUserReviews)));
};
var mapStateToProps = function(state) {
    if (!state.areas.account.me) {
        return {
            user: null,
            isAuthenticated: false
        };
    }
    return {
        user: {
            id: state.areas.account.me.id,
            displayName: state.areas.account.me.displayName
        },
        isAuthenticated: state.areas.account.isAuthenticated
    };
};
var dispatchActions = {
    likeReviewToggle: actions/* likeReviewToggle */.eX
};
/* harmony default export */ const reviews = ((0,es/* connect */.$j)(mapStateToProps, dispatchActions)(/*#__PURE__*/ (0,react.memo)(UserReviews)));


/***/ }),

/***/ 10849:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ like_button)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/modal/login-promo.js + 1 modules
var login_promo = __webpack_require__(25629);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
;// CONCATENATED MODULE: ./src/components/like-button/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  color: ",
        ";\n  align-items: center;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n\n    path {\n      fill: ",
        ";\n    }\n  }\n\n  gap: ",
        ";\n  transition: gap 150ms ease;\n\n  ",
        " {\n    overflow: hidden;\n    transition: max-width 150ms ease;\n    max-width: ",
        ";\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var LikeText = (0,styled_components_browser_esm["default"])(variants/* BodySmallText */.oI).withConfig({
    displayName: "LikeText",
    componentId: "sc-0-0"
})(_templateObject());
var StyledLikeButton = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "StyledLikeButton",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.theme.buttons.link.textHover;
}, function(p) {
    return p.liked ? 0 : base/* layout.measurements.spacing050 */.bK.measurements.spacing050;
}, LikeText, function(p) {
    return p.liked ? 0 : "999px";
});
var LikesWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LikesWrapper",
    componentId: "sc-0-2"
})(_templateObject2());
var LikeIconWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LikeIconWrapper",
    componentId: "sc-0-3"
})(_templateObject3());

// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-filled/index.js
var like_filled = __webpack_require__(5521);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/like-outlined/index.js
var like_outlined = __webpack_require__(49816);
;// CONCATENATED MODULE: ./src/components/like-button/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var LikeButton = function(param) {
    var className = param.className, onClick = param.onClick, liked = param.liked, likes = param.likes, _size = param.size, size = _size === void 0 ? 20 : _size, text = param.text;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(likes), 2), likeScore = ref[0], setLikeScore = ref[1];
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showLoginPromo = ref1[0], setShowLoginPromo = ref1[1];
    var handler = (0,react.useCallback)(function() {
        if (!isAuthenticated) {
            setShowLoginPromo(true);
            return;
        }
        onClick();
        // Fake a +1 in like score as the real data is not updated in real time
        if (!liked) {
            setLikeScore((likes || 0) + 1);
        }
    }, [
        onClick,
        likes,
        liked,
        isAuthenticated
    ]);
    var hideLoginPromo = (0,react.useCallback)(function() {
        setShowLoginPromo(false);
    }, []);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showLoginPromo ? /*#__PURE__*/ react.createElement(login_promo/* default */.Z, {
        isOpen: true,
        onRequestClose: hideLoginPromo
    }) : null, /*#__PURE__*/ react.createElement(StyledLikeButton, {
        onClick: handler,
        liked: liked,
        className: className
    }, /*#__PURE__*/ react.createElement(LikeText, null, text || t("reviews", "button.helpful")), /*#__PURE__*/ react.createElement(LikeIconWrapper, null, liked ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_filled/* IconLikeFilled */.G, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likeScore || 1)) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_outlined/* IconLikeOutlined */.q, {
        size: size,
        color: "maybeBlue700"
    }), /*#__PURE__*/ react.createElement(LikesWrapper, null, likes || null)))));
};
/* harmony default export */ const like_button = (LikeButton);


/***/ }),

/***/ 57515:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": () => (/* binding */ ActionType),
  "Z": () => (/* binding */ components_form)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(80054);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
;// CONCATENATED MODULE: ./src/components/review-form/components/form/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n  justify-content: flex-end;\n  position: sticky;\n  bottom: 0;\n  border-top: 1px solid ",
        ";\n  padding: ",
        " 0;\n  background: ",
        ";\n  z-index: 10;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    width: 50%;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 33%;\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Form = styled_components_browser_esm["default"].form.withConfig({
    displayName: "Form",
    componentId: "sc-0-0"
})(_templateObject());
var Buttons = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Buttons",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing150 */.bK.measurements.spacing150, function(p) {
    return p.theme.lines.primary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.bg.primary;
});
var SubmitButton = (0,styled_components_browser_esm["default"])(variants/* PrimaryButton */.KM).withConfig({
    displayName: "SubmitButton",
    componentId: "sc-0-2"
})(_templateObject3(), base/* media.mediumDown */.BC.mediumDown(_templateObject2()));
var CancelButton = (0,styled_components_browser_esm["default"])(variants/* TextButton */.Av).withConfig({
    displayName: "CancelButton",
    componentId: "sc-0-3"
})(_templateObject4(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var DeleteButton = (0,styled_components_browser_esm["default"])(variants/* OutlinedButton */.Uc).withConfig({
    displayName: "DeleteButton",
    componentId: "sc-0-4"
})(_templateObject5());

;// CONCATENATED MODULE: ./src/components/review-form/components/form/index.tsx






var ActionType;
(function(ActionType) {
    ActionType["CREATE"] = "create";
    ActionType["EDIT"] = "edit";
    ActionType["PUBLISH"] = "publish";
})(ActionType || (ActionType = {}));
var ReviewForm = function(param) {
    var className = param.className, children = param.children, id = param.id, onSubmit = param.onSubmit, onCancel = param.onCancel, onDelete = param.onDelete, pending = param.pending, actionType = param.actionType, onChange = param.onChange;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var formRef = (0,react.useRef)(null);
    var handleSubmit = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var formData = form_serialize_default()(formRef.current, {
            hash: true
        });
        onSubmit(formData);
    }, [
        onSubmit
    ]);
    var handleChange = (0,react.useCallback)(function() {
        if (onChange) {
            var formData = form_serialize_default()(formRef.current, {
                hash: true
            });
            onChange(formData);
        }
    }, [
        onChange
    ]);
    var submitButtonText = function() {
        switch(actionType){
            case "create":
                return t("account", "forgot-password.submit-button");
            case "publish":
                return t("reviews", "dialog.publish");
            default:
                return t("reviews", "dialog.update");
        }
    };
    return /*#__PURE__*/ react.createElement(Form, {
        className: className,
        method: "post",
        id: id,
        ref: formRef,
        onSubmit: handleSubmit,
        onChange: handleChange
    }, children, /*#__PURE__*/ react.createElement(Buttons, null, onDelete && /*#__PURE__*/ react.createElement(DeleteButton, {
        onClick: onDelete
    }, t("reviews", "dialog.delete")), onCancel && /*#__PURE__*/ react.createElement(CancelButton, {
        size: ui_button/* ButtonSize.SMALL */.qE.SMALL,
        onClick: onCancel
    }, t("common", "button.cancel")), /*#__PURE__*/ react.createElement(SubmitButton, {
        htmlType: "submit",
        size: ui_button/* ButtonSize.SMALL */.qE.SMALL,
        disabled: pending
    }, pending ? /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, {
        isActive: pending,
        position: "none"
    }) : submitButtonText())));
};
/* harmony default export */ const components_form = (ReviewForm);


/***/ }),

/***/ 52396:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33399);
/* harmony import */ var _prisjakt_ui_icon_info_outlined__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24050);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  font-size: ",
        ";\n  color: ",
        ";\n  max-width: 600px;\n  margin-bottom: ",
        ";\n  margin-top: ",
        ";\n\n  a {\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var InfoText = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].div.withConfig({
    displayName: "InfoText",
    componentId: "sc-0-0"
})(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.tertiary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Icon = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__["default"])(_prisjakt_ui_icon_info_outlined__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoOutlined */ .e).attrs({
    color: "base500"
}).withConfig({
    displayName: "Icon",
    componentId: "sc-0-1"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_2__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var Info = function(param) {
    var children = param.children;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(InfoText, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Icon, {
        size: 16
    }), children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Info);


/***/ }),

/***/ 13673:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "tr": () => (/* binding */ Variants)
/* harmony export */ });
/* unused harmony export Colors */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8176);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4012);
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/control-has-associated-label */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var Variants;
(function(Variants) {
    Variants["rate"] = "rate";
    Variants["scale"] = "scale";
    Variants["boolean"] = "boolean";
})(Variants || (Variants = {}));
var Colors;
(function(Colors) {
    Colors["negative"] = "negative";
    Colors["neutral"] = "neutral";
    Colors["positive"] = "positive";
})(Colors || (Colors = {}));
var ratingColorMap = [
    Colors.negative,
    Colors.negative,
    Colors.neutral,
    Colors.positive,
    Colors.positive
];
var MultiRadio = function(param) {
    var currentValue = param.currentValue, disabledOptions = param.disabledOptions, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, name = param.name, onClick = param.onClick, options = param.options, _optionValues = param.optionValues, optionValues = _optionValues === void 0 ? [] : _optionValues, required = param.required, _size = param.size, size = _size === void 0 ? "medium" : _size, variant = param.variant;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).t;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? optionValues[currentValue - 1] : undefined), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? ratingColorMap[currentValue - 1] : Colors.neutral), 2), ratingColor = ref1[0], setRatingColor = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), error = ref2[0], setError = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue), 2), checked = ref3[0], setChecked = ref3[1];
    var getSize = function() {
        switch(size){
            case "small":
                return 20;
            case "medium":
            default:
                return 32;
        }
    };
    var iconSize = getSize();
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.target.checkValidity()) {
            setError(null);
        }
        setSelected(e.target.dataset.value);
        setChecked(parseInt(e.target.value, 10));
        if (variant === Variants.rate) {
            var index = Number(e.target.value) - 1;
            setRatingColor(ratingColorMap[index]);
        }
        if (onClick) onClick(e);
    }, [
        onClick,
        variant
    ]);
    var getIsDisabled = function(option) {
        return (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.length) ? (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.find(function(item) {
            return item === option;
        })) !== undefined : false;
    };
    var handleInvalidity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (error === e.target.name) return;
        setError(e.target.name);
    }, [
        error
    ]);
    if (variant === Variants.rate) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity
        }, options.map(function(option, index) {
            switch(option){
                case 1:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngryIcon */ .u7, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 2:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfiedIcon */ .fV, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 3:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutralIcon */ .cI, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 4:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmilingIcon */ .oX, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 5:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues.length ? optionValues[index] : undefined,
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughingIcon */ .mv, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                default:
                    return null;
            }
        }), selected && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .SelectedRating */ .u1, {
            color: ratingColor
        }, selected)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.scale) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            hasSelected: Boolean(optionValues.length),
            showError: error === name
        }, optionValues.length ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Selected */ .Ne, null, selected !== null && selected !== void 0 ? selected : t("reviews", "form.question-nothing-selected")) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, options.map(function(option, index) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                key: option
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ScaleRadio */ .az, {
                type: "radio",
                name: name,
                id: "".concat(name, ":").concat(option),
                value: option,
                "data-value": optionValues.length ? optionValues[index] : undefined,
                required: required,
                onChange: handleChange,
                alignRight: index + 1 === options.length,
                alignLeft: index === 0,
                showError: error === name,
                tabIndex: 0,
                checked: checked === option
            }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                htmlFor: "".concat(name, ":").concat(option),
                "data-label": labels.length ? labels[index] : null
            }));
        }))), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.boolean) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            showError: error === name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":1"),
            value: "1",
            "data-value": t("reviews", "form.boolean-yes"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 1
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":1")
        }, t("reviews", "form.boolean-yes"))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":0"),
            value: "0",
            "data-value": t("reviews", "form.boolean-no"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 0
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":0")
        }, t("reviews", "form.boolean-no"))), options.length > 2 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":2"),
            value: "2",
            "data-value": t("reviews", "form.boolean-unknown"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 2
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":2")
        }, t("reviews", "form.boolean-no"))) : null)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiRadio);


/***/ }),

/***/ 8176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N$": () => (/* binding */ RadioRating),
/* harmony export */   "Ne": () => (/* binding */ Selected),
/* harmony export */   "az": () => (/* binding */ ScaleRadio),
/* harmony export */   "cI": () => (/* binding */ EmoticonNeutralIcon),
/* harmony export */   "fV": () => (/* binding */ EmoticonDissatisfiedIcon),
/* harmony export */   "jj": () => (/* binding */ Error),
/* harmony export */   "kq": () => (/* binding */ Inputs),
/* harmony export */   "mv": () => (/* binding */ EmoticonLaughingIcon),
/* harmony export */   "ng": () => (/* binding */ MultiRadio),
/* harmony export */   "oX": () => (/* binding */ EmoticonSmilingIcon),
/* harmony export */   "qV": () => (/* binding */ BooleanRadio),
/* harmony export */   "u1": () => (/* binding */ SelectedRating),
/* harmony export */   "u7": () => (/* binding */ EmoticonAngryIcon),
/* harmony export */   "uZ": () => (/* binding */ RadioDot)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var src_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31913);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13673);
/* stylelint-disable */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: 0;\n  position: absolute;\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          height: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            top: ",
        "px;\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      position: relative;\n      height: ",
        ";\n      align-items: flex-start;\n      width: 100%;\n\n      ",
        ";\n\n      ",
        " {\n        width: 100%;\n        justify-content: space-between;\n\n        &::after {\n          content: '';\n          width: 100%;\n          position: absolute;\n          top: ",
        "px;\n          z-index: 1;\n          border-top: 1px solid\n            ",
        ";\n\n          ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      background: #eee;\n      padding: 2px;\n      border-radius: 4px;\n\n      box-shadow: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    border-radius: 20px;\n    background: ",
        ";\n    padding: 1px ",
        ";\n    color: ",
        ";\n    line-height: initial;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  height: 20px;\n  max-height: 20px;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  background: #eee;\n  border-radius: 5px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n          margin-right: ",
        ";\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      line-height: 0;\n\n      &:not(:last-of-type) {\n        margin-right: ",
        ";\n\n        ",
        "\n      }\n    }\n\n    &:checked + label {\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n    }\n\n    &.focus-visible + label {\n      ",
        ",\n      ",
        ",\n    ",
        ",\n    ",
        ",\n    ",
        " {\n        box-shadow: 0 0 0 2px ",
        ";\n      }\n    }\n\n    &:disabled + label {\n      cursor: not-allowed;\n    }\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n          right: 0;\n          left: unset;\n          transform: translateX(0);\n          text-align: right;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          transform: translateX(0);\n          text-align: left;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      z-index: 2;\n      border-radius: ",
        "px;\n      border: 1px solid\n        ",
        ";\n\n      ",
        ";\n\n      position: relative;\n\n      &::after {\n        content: attr(data-label);\n        position: absolute;\n        align-self: center;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: ",
        ";\n        color: ",
        ";\n        width: 100px;\n        font-size: ",
        ";\n        text-align: center;\n        white-space: nowrap;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    }\n\n    &:checked + label > ",
        " {\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      border-radius: 50%;\n\n      ",
        ";\n    }\n\n    &.focus-visible + label {\n      border: 2px solid ",
        ";\n    }\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n        padding: ",
        " ",
        ";\n      "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      padding: ",
        "\n        ",
        ";\n      border-radius: 5px;\n      white-space: nowrap;\n      user-select: none;\n\n      ",
        ";\n    }\n\n    &:checked + label {\n      background: #fff;\n    }\n\n    &.focus-visible + label {\n      box-shadow: 0 0 0 2px ",
        ";\n    }\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}




var CHECKBOX_SIZE = {
    DESKTOP: 18,
    MOBILE: 18
};
var disabledInputStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var Inputs = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inputs",
    componentId: "sc-0-0"
})(_templateObject1());
var RadioDot = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "RadioDot",
    componentId: "sc-0-1"
})(_templateObject2());
var MultiRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MultiRadio",
    componentId: "sc-0-2"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8(), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.rate */ .tr.rate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3()), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.scale */ .tr.scale && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), p.hasSelected ? "80px" : "60px", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4(), p.hasSelected ? "90px" : "70px"), Inputs, CHECKBOX_SIZE.DESKTOP / 2, p.showError ? p.theme.text.negative : p.theme.lines.tertiary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5(), CHECKBOX_SIZE.MOBILE / 2)), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : "none"));
});
var SelectedRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SelectedRating",
    componentId: "sc-0-3"
})(function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, theme.ratings[color].bg, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, theme.ratings[color].fg);
});
var Selected = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Selected",
    componentId: "sc-0-4"
})(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var iconStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), function(p) {
    return p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : 0;
});
var EmoticonAngryIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngry */ .Sd).withConfig({
    displayName: "EmoticonAngryIcon",
    componentId: "sc-0-5"
})(_templateObject12(), iconStyling);
var EmoticonDissatisfiedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfied */ ._z).withConfig({
    displayName: "EmoticonDissatisfiedIcon",
    componentId: "sc-0-6"
})(_templateObject13(), iconStyling);
var EmoticonNeutralIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutral */ .sS).withConfig({
    displayName: "EmoticonNeutralIcon",
    componentId: "sc-0-7"
})(_templateObject14(), iconStyling);
var EmoticonSmilingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmiling */ .wr).withConfig({
    displayName: "EmoticonSmilingIcon",
    componentId: "sc-0-8"
})(_templateObject15(), iconStyling);
var EmoticonLaughingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughing */ .X3).withConfig({
    displayName: "EmoticonLaughingIcon",
    componentId: "sc-0-9"
})(_templateObject16(), iconStyling);
var RadioRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "RadioRating",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, props.$size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), EmoticonAngryIcon, props.theme.ratings.negative.bg, EmoticonDissatisfiedIcon, props.theme.ratings.negative.bg, EmoticonNeutralIcon, props.theme.ratings.neutral.bg, EmoticonSmilingIcon, props.theme.ratings.positive.bg, EmoticonLaughingIcon, props.theme.ratings.positive.bg, EmoticonAngryIcon, EmoticonDissatisfiedIcon, EmoticonNeutralIcon, EmoticonSmilingIcon, EmoticonLaughingIcon, props.theme.icons.callToAction);
});
var ScaleRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "ScaleRadio",
    componentId: "sc-0-11"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject23(), disabledInputStyles, CHECKBOX_SIZE.DESKTOP, CHECKBOX_SIZE.DESKTOP, p.theme.bg.primary, CHECKBOX_SIZE.DESKTOP, p.showError ? p.theme.text.negative : p.theme.lines.quaternary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject19(), CHECKBOX_SIZE.MOBILE, CHECKBOX_SIZE.MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, p.alignRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20()), p.alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject21()), RadioDot, CHECKBOX_SIZE.DESKTOP - 6, CHECKBOX_SIZE.DESKTOP - 6, p.theme.lines.highlight, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject22(), CHECKBOX_SIZE.MOBILE - 6, CHECKBOX_SIZE.MOBILE - 6), p.theme.icons.callToAction);
});
var BooleanRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "BooleanRadio",
    componentId: "sc-0-12"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject25(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150), p.theme.icons.callToAction);
});
var Error = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Error",
    componentId: "sc-0-13"
})(_templateObject26(), function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100 : 0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.text.negative, "0.1") : "none";
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 14521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": () => (/* binding */ TextTypes),
  "Z": () => (/* binding */ components_text)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
;// CONCATENATED MODULE: ./src/components/review-form/components/text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 600px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  textarea {\n    border-radius: 2px;\n    width: 100%;\n    min-height: 100px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  input {\n    border-radius: 2px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  min-height: 18px;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  color: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var TextWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var TextArea = (0,styled_components_browser_esm["default"])(inputs/* TextArea */.Kx).withConfig({
    displayName: "TextArea",
    componentId: "sc-0-1"
})(_templateObject1());
var TextInput = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).withConfig({
    displayName: "TextInput",
    componentId: "sc-0-2"
})(_templateObject2());
var Counter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Counter",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.tertiary;
});
var Count = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Count",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.text[p.color];
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var Error = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Error",
    componentId: "sc-0-5"
})(_templateObject5(), function(p) {
    return p.background ? base/* layout.measurements.spacing100 */.bK.measurements.spacing100 : 0;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.background ? base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.text.negative, "0.1") : "none";
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/check-filled/index.js
var check_filled = __webpack_require__(44703);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/info-filled/index.js
var info_filled = __webpack_require__(4012);
;// CONCATENATED MODULE: ./src/components/review-form/components/text/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var TextTypes;
(function(TextTypes) {
    TextTypes["TextArea"] = "textarea";
    TextTypes["Email"] = "email";
    TextTypes["Text"] = "text";
})(TextTypes || (TextTypes = {}));
var Text = function(param) {
    var name = param.name, required = param.required, placeholder = param.placeholder, _minLength = param.minLength, minLength = _minLength === void 0 ? 0 : _minLength, defaultValue = param.defaultValue, _type = param.type, type = _type === void 0 ? TextTypes.TextArea : _type;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)((defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.length) || 0), 2), characterCount = ref[0], setCharacterCount = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), showError = ref1[0], setShowError = ref1[1];
    var handleChange = (0,react.useCallback)(function(e) {
        setCharacterCount(e.target.value.length);
    }, []);
    var handleInvalidity = (0,react.useCallback)(function(e) {
        setShowError(e.target.name === name);
    }, [
        name
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(TextWrapper, null, type === TextTypes.TextArea ? /*#__PURE__*/ react.createElement(TextArea, {
        name: name,
        minLength: minLength,
        required: required,
        placeholder: placeholder,
        onChange: handleChange,
        onInvalid: handleInvalidity,
        warning: showError,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : undefined
    }) : /*#__PURE__*/ react.createElement(TextInput, {
        name: name,
        type: type,
        placeholder: placeholder,
        required: required,
        onChange: handleChange,
        onInvalid: handleInvalidity,
        warning: showError,
        defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : undefined
    }), /*#__PURE__*/ react.createElement(Counter, null, required && minLength > 0 || characterCount && minLength > 0 ? /*#__PURE__*/ react.createElement(Count, {
        color: characterCount >= minLength ? "positive" : "quaternary"
    }, characterCount >= minLength ? /*#__PURE__*/ react.createElement(check_filled/* IconCheckFilled */.i, {
        size: 16,
        color: "positive500"
    }) : null, t("reviews", "form.text-length-requirement", {
        curr: characterCount,
        min: minLength
    })) : null)), showError && /*#__PURE__*/ react.createElement(Error, null, /*#__PURE__*/ react.createElement(info_filled/* IconInfoFilled */.h, {
        size: 16,
        color: "negative700"
    }), " ", type === TextTypes.Email ? t("errors", "validation.email-invalid") : t("reviews", "form.error-text")));
};
/* harmony default export */ const components_text = (Text);


/***/ }),

/***/ 67209:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ review_text)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/areas/reviews/review-context.tsx
var review_context = __webpack_require__(56132);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n\n  img {\n    margin-top: 2px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  button {\n    cursor: pointer;\n    text-decoration: underline;\n    color: ",
        ";\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  margin: ",
        " 0;\n  border-radius: 5px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  padding-bottom: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  float: right;\n\n  &::first-letter {\n    text-transform: capitalize;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: pre-line;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: none;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    white-space: pre-line;\n    word-break: break-word;\n    font-weight: 400;\n    color: ",
        ";\n    max-height: 5.7ex;\n    overflow: hidden;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 80ch;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: none;\n  margin-top: ",
        ";\n  font-size: ",
        ";\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n  margin-right: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n\n  &::after {\n    color: ",
        ";\n    content: '•';\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var TranslationOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptions",
    componentId: "sc-0-0"
})(_templateObject(), function(p) {
    return p.theme.text.tertiary;
});
var TranslationOptionsService = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsService",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var TranslationOptionsToggle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TranslationOptionsToggle",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Reply = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Reply",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.theme.bg.secondary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ReplyName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyName",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.text.secondary;
}, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall);
var ReplyDate = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ReplyDate",
    componentId: "sc-0-5"
})(_templateObject5());
var ReplyText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReplyText",
    componentId: "sc-0-6"
})(_templateObject6());
var TextLabel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TextLabel",
    componentId: "sc-0-7"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), function(p) {
        return p.theme.text.primary;
    }, props.fullText && (0,styled_components_browser_esm.css)(_templateObject7()));
});
var Text = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Text",
    componentId: "sc-0-8"
})(_templateObject9());
var ReadMore = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ReadMore",
    componentId: "sc-0-9"
})(_templateObject10(), function(p) {
    return p.theme.text.linkExternal;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal, function(p) {
    return p.theme.text.linkExternalHover;
});
var Dates = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Dates",
    componentId: "sc-0-10"
})(_templateObject11(), base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.quaternary;
}, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Divider = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-11"
})(_templateObject12(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.fontSizeSmall */.bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.quaternary;
});
var ReviewContentWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ReviewContentWrapper",
    componentId: "sc-0-12"
})(_templateObject13());

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/review-text/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var ReviewText = function(param) {
    var id = param.id, translation = param.translation, text = param.text, reply = param.reply;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onReviewExpansion = (0,review_context/* useReviewContext */.A)().onReviewExpansion;
    var ref = _slicedToArray((0,react.useState)(false), 2), showMore = ref[0], setShowMore = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), isExpanded = ref1[0], setIsExpanded = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), showOriginal = ref2[0], setShowOriginal = ref2[1];
    var textNode = (0,react.useCallback)(function(node) {
        if (node && node.parentElement) {
            var textHeight = node.getBoundingClientRect().height;
            var wrapperHeight = node.parentElement.getBoundingClientRect().height;
            setShowMore(textHeight > wrapperHeight);
        }
    }, []);
    var collapseOrExpand = isExpanded ? "symbol.collapse" : "symbol.expand";
    var reviewTextIdentifier = "review-text-".concat(id);
    var expansionText = isExpanded ? t("common", "button.show-less") : t("common", "button.show-more");
    var reviewText = showOriginal && translation ? translation.text : text;
    var toggleExpansion = function() {
        setIsExpanded(!isExpanded);
        if (onReviewExpansion) onReviewExpansion();
    };
    var toggleTranslation = function() {
        setShowOriginal(!showOriginal);
    };
    var renderTranslation = function() {
        if (!translation || !translation.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(TranslationOptions, null, /*#__PURE__*/ react.createElement(TranslationOptionsService, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
            domain: "reviews"
        }, translation.service && translation.service.name ? "translation.translated-by-".concat(translation.service.name.toLowerCase(), ".md") : "translation.translated")), /*#__PURE__*/ react.createElement(TranslationOptionsToggle, null, /*#__PURE__*/ react.createElement("button", {
            type: "button",
            onClick: toggleTranslation
        }, showOriginal ? t("reviews", "translation.show-translation") : t("reviews", "translation.show-original"))));
    };
    var renderReply = function() {
        if (!reply || !reply.text) {
            return null;
        }
        return /*#__PURE__*/ react.createElement(Reply, null, /*#__PURE__*/ react.createElement(ReplyName, null, t("reviews", "store.reply-by", {
            name: reply.name
        }), reply.date && /*#__PURE__*/ react.createElement(ReplyDate, null, reply.date)), /*#__PURE__*/ react.createElement(ReplyText, null, reply.text.trim()));
    };
    return /*#__PURE__*/ react.createElement(ReviewContentWrapper, null, /*#__PURE__*/ react.createElement(TextLabel, {
        id: reviewTextIdentifier,
        fullText: isExpanded
    }, /*#__PURE__*/ react.createElement(Text, {
        ref: textNode
    }, reviewText && reviewText.trim())), showMore && /*#__PURE__*/ react.createElement(ReadMore, {
        onClick: toggleExpansion,
        "aria-label": t("symbols", collapseOrExpand),
        "aria-expanded": isExpanded,
        "aria-controls": reviewTextIdentifier
    }, expansionText), translation && renderTranslation(), reply && renderReply());
};
/* harmony default export */ const review_text = (ReviewText);


/***/ }),

/***/ 55840:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$t": () => (/* binding */ UserAvatarClickableStyle),
/* harmony export */   "SD": () => (/* binding */ UserAvatarStyle),
/* harmony export */   "ZT": () => (/* binding */ USER_AVATAR_SIZE),
/* harmony export */   "jP": () => (/* binding */ ReviewUserAvatar)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87172);
/* harmony import */ var src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40142);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42779);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10297);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var USER_AVATAR_SIZE = 32;
var UserAvatarStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_user_avatar__WEBPACK_IMPORTED_MODULE_3__/* .UserAvatar */ .Y).withConfig({
    displayName: "UserAvatarStyle",
    componentId: "sc-0-0"
})(_templateObject());
var UserAvatarClickableStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_2__/* .Clickable */ .P).withConfig({
    displayName: "UserAvatarClickableStyle",
    componentId: "sc-0-1"
})(_templateObject1());
var ReviewUserAvatar = function(param) {
    var userId = param.userId, userAvatar = param.userAvatar, userDisplayName = param.userDisplayName, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il), t = ref.t, market = ref.market, renderMode = ref.renderMode;
    var isRegisteredUser = Boolean(userId);
    var isRegisteredUserWithUsername = Boolean(userDisplayName && userId);
    var isExternalUser = !isRegisteredUser && Boolean(userDisplayName);
    var displayName = t("reviews", "user.guest");
    var avatar = "".concat(market.cdn, "/g/rfe/icons/anon-avatar.png");
    if (isRegisteredUserWithUsername || isExternalUser) {
        displayName = userDisplayName;
    }
    if (isRegisteredUserWithUsername) {
        avatar = userAvatar;
    }
    if (isExternalUser) {
        avatar = null;
    }
    var avatarProps = {
        avatar: avatar,
        displayName: displayName,
        size: USER_AVATAR_SIZE,
        isLinked: isRegisteredUser,
        unregisteredUser: Boolean(unregisteredUser),
        isFakeAccount: Boolean(isFakeAccount)
    };
    if (isRegisteredUser && !isFakeAccount) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarClickableStyle, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps)));
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(UserAvatarStyle, _extends({}, avatarProps));
};


/***/ }),

/***/ 36950:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": () => (/* binding */ ReviewUsername)
/* harmony export */ });
/* unused harmony export UsernameStyle */
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5492);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66431);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87172);
/* harmony import */ var src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42779);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10297);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 156px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var UsernameStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__/* .BodySmallText */ .oI).withConfig({
    displayName: "UsernameStyle",
    componentId: "sc-0-0"
})(_templateObject());
var checkRegistered = function(name, unregisteredUser, message) {
    return !unregisteredUser ? name : message;
};
var ReviewUsername = function(param) {
    var userId = param.userId, userDisplayName = param.userDisplayName, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .AppContext */ .Il), t = ref.t, renderMode = ref.renderMode;
    var usernameText = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(UsernameStyle, {
        container: "div",
        weight: _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_0__/* .FontWeight.HEAVIER */ .U9.HEAVIER,
        flex: false
    }, checkRegistered(userDisplayName, unregisteredUser, t("reviews", "user.unregistered")) || t("reviews", "user.guest"));
    if (userId && !isFakeAccount) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P, {
            to: "/user/".concat(userId),
            isExternal: renderMode === "native",
            onClick: function() {
                return (0,src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .trackInternalNavigationClick */ .p)({
                    scope: src_globals_tracking_tracking__WEBPACK_IMPORTED_MODULE_4__/* .InternalNavigationScope.REVIEW_USER_CARD */ .U.REVIEW_USER_CARD,
                    nextPage: "/user/".concat(userId)
                });
            }
        }, usernameText);
    }
    return usernameText;
};


/***/ }),

/***/ 64318:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": () => (/* binding */ useReviewLikeHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3732);
/* harmony import */ var src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93302);
/* harmony import */ var src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96328);




var selectLikedReviews = function(state) {
    var ref, ref1;
    return (ref = state.areas.account.me) === null || ref === void 0 ? void 0 : (ref1 = ref.likes) === null || ref1 === void 0 ? void 0 : ref1.reviews;
};
var useReviewLikeHandler = function(param) {
    var id = param.id, type = param.type;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var likedReviews = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(selectLikedReviews);
    var isAuthenticated = (0,src_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_3__/* .useIsAuthenticated */ .k)();
    var liked = Boolean(likedReviews === null || likedReviews === void 0 ? void 0 : likedReviews.includes(id));
    var onLike = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (isAuthenticated) {
            dispatch((0,src_areas_reviews_actions__WEBPACK_IMPORTED_MODULE_2__/* .likeReviewToggle */ .eX)(id, type));
        }
    }, [
        dispatch,
        isAuthenticated,
        type,
        id
    ]);
    return {
        liked: liked,
        onLike: onLike
    };
};


/***/ }),

/***/ 15556:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ useReviewReportHandler)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var useReviewReportHandler = function(param) {
    var id = param.id;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), reportingReviewId = ref[0], setReportingReviewId = ref[1];
    var onReportIntent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(id);
    }, [
        id
    ]);
    var onReportCompleted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setReportingReviewId(null);
    }, []);
    return {
        reportingReviewId: reportingReviewId,
        onReportIntent: onReportIntent,
        onReportCompleted: onReportCompleted
    };
};


/***/ }),

/***/ 95846:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": () => (/* binding */ useReviewViewedTracking)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/reviews/tracking/index.ts
var tracking = __webpack_require__(19685);
;// CONCATENATED MODULE: ./node_modules/.pnpm/observe-element-in-viewport@0.0.15/node_modules/observe-element-in-viewport/dist/index.esm.js
function o(o,r,t,e){if(void 0===t&&(t=function(){}),void 0===e&&(e={}),!o)throw new Error("Target element to observe should be a valid DOM Node");var n=Object.assign({},{viewport:null,modTop:"0px",modRight:"0px",modBottom:"0px",modLeft:"0px",threshold:[0]},e),i=n.viewport,a=n.modTop,u=n.modLeft,s=n.modBottom,f=n.modRight,d=n.threshold;if(!Array.isArray(d)&&"number"!=typeof d)throw new Error("threshold should be a number or an array of numbers");var h=Array.isArray(d)?d.map(function(o){return Math.floor(o%101)/100}):[Math.floor(d?d%101:0)/100],c=Math.min.apply(Math,h),m={root:i instanceof Node?i:null,rootMargin:a+" "+f+" "+s+" "+u,threshold:h},l=new IntersectionObserver(function(e,n){var i=e.filter(function(r){return r.target===o})[0],a=function(){return n.unobserve(o)};i&&(i.isInViewport=i.isIntersecting&&i.intersectionRatio>=c,i.isInViewport?r(i,a,o):t(i,a,o))},m);return l.observe(o),function(){return l.unobserve(o)}}var r=function(r,t){return void 0===t&&(t={}),new Promise(function(e,n){try{o(r,function(o,r){r(),e(!0)},function(o,r){r(),e(!1)},t)}catch(o){n(o)}})};
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./node_modules/.pnpm/use-is-in-viewport@1.0.9_react@18.1.0/node_modules/use-is-in-viewport/built/index.esm.js
function index_esm_o(r){return"object"==typeof r&&"current"in r}function c(r){return"function"==typeof r&&"function"==typeof r.call}/* harmony default export */ function index_esm(i){void 0===i&&(i={});var f=(0,react.useState)(null),p=f[0],l=f[1],a=i.target,v=i.viewport,m=function(r,t){var n={};for(var e in r)Object.prototype.hasOwnProperty.call(r,e)&&-1===t.indexOf(e)&&(n[e]=r[e]);return n}(i,["target","viewport"]),w=(0,react.useRef)(null),y=(0,react.useRef)(null),b=(0,react.useCallback)(function(r){w.current=r,v&&(c(v)?v(r):index_esm_o(v)&&(v.current=r))},[w,v]),s=(0,react.useCallback)(function(r){y.current=r,a&&(c(a)?a(r):index_esm_o(a)&&(a.current=r))},[y,a]);return (0,react.useEffect)(function(){if(y.current)return o(y.current,function(){return l(!0)},function(){return l(!1)},Object.assign({},m,{viewport:w.current}))},[y.current,m,w]),[p,s,b]}
//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/hooks/use-viewed-tracking.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var useReviewViewedTracking = function(param) {
    var type = param.type;
    var userReviewRef = (0,react.useRef)(null);
    var ref = _slicedToArray(index_esm({
        target: userReviewRef
    }), 2), isInViewport = ref[0], reviewElementRef = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), reviewViewed = ref1[0], setReviewViewed = ref1[1];
    (0,react.useEffect)(function() {
        // Track viewed reviews
        if (isInViewport && !reviewViewed) {
            setReviewViewed(true);
            if (type === "store") {
                (0,tracking/* storeReviewViewed */.J8)();
            }
            if (type === "product") {
                (0,tracking/* productReviewViewed */.G0)();
            }
        }
    }, [
        type,
        isInViewport,
        reviewViewed
    ]);
    return {
        reviewElementRef: reviewElementRef
    };
};


/***/ }),

/***/ 80574:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/edit/index.js
var edit = __webpack_require__(56662);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(92826);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(64478);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(87838);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/reviews/components/prompt/index.js
var components_prompt = __webpack_require__(82951);
// EXTERNAL MODULE: ./src/areas/reviews/components/report/index.js + 2 modules
var report = __webpack_require__(62539);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/like-button/index.tsx + 1 modules
var like_button = __webpack_require__(10849);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./src/components/currency/index.tsx + 2 modules
var currency = __webpack_require__(7846);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/product-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  height: 40px;\n  width: 40px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 600;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  grid-template-rows: 1fr 1fr;\n  grid-gap: ",
        " ",
        ";\n  padding: ",
        ";\n  position: relative;\n  align-items: center;\n\n  ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n  }\n\n  ",
        " {\n    grid-area: 1 / 2 / 2 / 4;\n  }\n\n  ",
        " {\n    grid-area: 2 / 2 / 3 / 3;\n  }\n\n  ",
        " {\n    grid-area: 2 / 3 / 3 / 4;\n  }\n\n  &::after {\n    ",
        "\n    border-radius: 5px;\n    pointer-events: none;\n    transition: background-color 150ms ease;\n  }\n\n  &:hover {\n    &::after {\n      background-color: rgba(0, 0, 0, 0.07);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-0"
})(_templateObject());
var Currency = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Currency",
    componentId: "sc-0-1"
})(_templateObject1());
var ProductRating = (0,styled_components_browser_esm["default"])(components_rating/* default */.Z).withConfig({
    displayName: "ProductRating",
    componentId: "sc-0-2"
})(_templateObject2());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-3"
})(_templateObject3());
var Product = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Product",
    componentId: "sc-0-4"
})(_templateObject4(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, ProductImage, ProductName, ProductRating, Currency, base/* styledUtils.overlay */.au.overlay());

;// CONCATENATED MODULE: ./src/components/user-review-card-v2/components/product-card/index.tsx



var UserReviewProductCard = function(param) {
    var name = param.name, image = param.image, rating = param.rating, ratingCount = param.ratingCount, price = param.price, pathName = param.pathName;
    return /*#__PURE__*/ react.createElement(Product, {
        to: pathName
    }, image && /*#__PURE__*/ react.createElement(ProductImage, null, /*#__PURE__*/ react.createElement("img", {
        width: 40,
        src: image,
        alt: ""
    })), /*#__PURE__*/ react.createElement(ProductName, null, name), /*#__PURE__*/ react.createElement(ProductRating, {
        rate: rating,
        singleStar: true,
        showRate: true,
        showCounter: true,
        count: ratingCount,
        countTranslation: {
            domain: "product",
            key: "product-card.n-ratings"
        }
    }), price ? /*#__PURE__*/ react.createElement(Currency, null, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: price
    })) : null);
};

// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/review-text/index.tsx + 1 modules
var review_text = __webpack_require__(67209);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/user/user-avatar.tsx
var user_avatar = __webpack_require__(55840);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/components/user/username.tsx
var username = __webpack_require__(36950);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/hooks/use-like-handler.ts
var use_like_handler = __webpack_require__(64318);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/hooks/use-report-handler.ts
var use_report_handler = __webpack_require__(15556);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/hooks/use-viewed-tracking.ts + 2 modules
var use_viewed_tracking = __webpack_require__(95846);
// EXTERNAL MODULE: ./src/components/user-review-card-v2/styles.ts
var styles = __webpack_require__(28127);
;// CONCATENATED MODULE: ./src/components/user-review-card-v2/product.tsx




















var ProductUserReviewCard = function(param) {
    var className = param.className, id = param.id, text = param.text, rating = param.rating, purchaseDate = param.purchaseDate, translation = param.translation, createdAt = param.createdAt, updatedAt = param.updatedAt, createdAtFromNow = param.createdAtFromNow, updatedAtFromNow = param.updatedAtFromNow, userId = param.userId, userAvatar = param.userAvatar, userDisplayName = param.userDisplayName, userReviewCount = param.userReviewCount, unregisteredUser = param.unregisteredUser, isFakeAccount = param.isFakeAccount, likes = param.likes, belongsTo = param.belongsTo, isMyReview = param.isMyReview, _product = param.product, product = _product === void 0 ? null : _product, _showProduct = param.showProduct, showProduct = _showProduct === void 0 ? false : _showProduct, _showFooter = param.showFooter, showFooter = _showFooter === void 0 ? true : _showFooter, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded;
    var ref, ref1, ref2, ref3, ref4;
    var reviewElementRef = (0,use_viewed_tracking/* useReviewViewedTracking */.$)({
        type: "product"
    }).reviewElementRef;
    var ref5 = (0,use_report_handler/* useReviewReportHandler */.Q)({
        id: id
    }), reportingReviewId = ref5.reportingReviewId, onReportIntent = ref5.onReportIntent, onReportCompleted = ref5.onReportCompleted;
    var ref6 = (0,use_like_handler/* useReviewLikeHandler */.q)({
        id: id,
        type: "product"
    }), liked = ref6.liked, onLike = ref6.onLike;
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var ref7 = (0,react.useContext)(app_context/* AppContext */.Il), t = ref7.t, market = ref7.market;
    var isMine = isMyReview && isAuthenticated;
    var currentReview = (0,react.useMemo)(function() {
        return {
            id: id,
            rating: rating,
            reviewText: text,
            purchaseDate: purchaseDate
        };
    }, [
        id,
        rating,
        text,
        purchaseDate
    ]);
    // NOTE: Hides the purchase date on markets where this is not a requirement
    // because it does not accurately represent the actual date of purchase.
    // Should be fixed and enabled when the new review service is in place.
    var showPurchaseDate = Boolean((ref = market.modules) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewPurchaseDate) === null || ref1 === void 0 ? void 0 : ref1.enabled);
    if (!id) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, reportingReviewId ? /*#__PURE__*/ react.createElement(report/* default */.Z, {
        review: reportingReviewId,
        onComplete: onReportCompleted,
        type: "product"
    }) : null, /*#__PURE__*/ react.createElement(styles/* UserReviewCard */.IR, {
        $expanded: expanded,
        className: className,
        containerProps: {
            "data-test": "UserReviewCard",
            ref: reviewElementRef
        }
    }, product && showProduct && /*#__PURE__*/ react.createElement(UserReviewProductCard, {
        name: product.name,
        image: (ref2 = product.media) === null || ref2 === void 0 ? void 0 : ref2.first,
        rating: ((ref3 = product.aggregatedRating) === null || ref3 === void 0 ? void 0 : ref3.score) || product.userReviewSummary.rating,
        ratingCount: ((ref4 = product.aggregatedRating) === null || ref4 === void 0 ? void 0 : ref4.count) || product.userReviewSummary.count,
        price: product.priceSummary.regular,
        pathName: product.pathName
    }), /*#__PURE__*/ react.createElement(styles/* UserInfo */.ao, null, /*#__PURE__*/ react.createElement(user_avatar/* ReviewUserAvatar */.jP, {
        userId: userId,
        userAvatar: userAvatar,
        userDisplayName: !unregisteredUser ? userDisplayName : t("reviews", "user.unregistered"),
        unregisteredUser: unregisteredUser,
        isFakeAccount: isFakeAccount
    }), /*#__PURE__*/ react.createElement(styles/* UserInfoRow */.f9, null, /*#__PURE__*/ react.createElement(username/* ReviewUsername */.n, {
        userId: userId,
        userDisplayName: userDisplayName,
        unregisteredUser: unregisteredUser,
        isFakeAccount: isFakeAccount
    }), userReviewCount && userReviewCount > 0 ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(styles/* Divider */.iz, null), /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, {
        $bold: true
    }, t("reviews", "user.total-reviews", {
        n: userReviewCount
    }))) : null), /*#__PURE__*/ react.createElement(styles/* UserInfoRow */.f9, null, rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        rate: rating
    }) : null, createdAt || updatedAt ? /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, {
        containerProps: {
            title: createdAt
        }
    }, updatedAt && t("reviews", "info.edited", {
        date: updatedAtFromNow || updatedAt
    }), !updatedAt && createdAt && t("reviews", "info.created", {
        date: createdAtFromNow || createdAt
    })) : null, showPurchaseDate && purchaseDate ? /*#__PURE__*/ react.createElement(react.Fragment, null, createdAt || updatedAt ? /*#__PURE__*/ react.createElement(styles/* Divider */.iz, null) : null, /*#__PURE__*/ react.createElement(styles/* UserInfoText */.Wn, null, t("reviews", "info.purchased", {
        date: purchaseDate
    }))) : null)), /*#__PURE__*/ react.createElement(styles/* Review */.Cq, null, Boolean(text) && /*#__PURE__*/ react.createElement(review_text/* default */.Z, {
        id: id,
        text: text,
        translation: translation
    })), showFooter ? /*#__PURE__*/ react.createElement(styles/* Footer */.$_, null, /*#__PURE__*/ react.createElement(styles/* FooterContent */.Bp, null, likes && isMine ? /*#__PURE__*/ react.createElement(styles/* Statistic */.$k, null, /*#__PURE__*/ react.createElement(styles/* ThumbsUpIcon */.lb, {
        size: 16
    }), " ", likes) : null, isMine ? /*#__PURE__*/ react.createElement(styles/* Edit */.I8, null, /*#__PURE__*/ react.createElement(components_prompt/* default */.Z, {
        belongsTo: belongsTo,
        currentReview: currentReview,
        control: /*#__PURE__*/ react.createElement(variants/* TextButton */.Av, {
            size: variants/* ButtonSize.SMALL */.qE.SMALL
        }, /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(edit/* IconEdit */.y, null)), /*#__PURE__*/ react.createElement(variants/* ButtonText */.oD, null, t("common", "button.edit")))
    })) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(like_button/* default */.Z, {
        onClick: onLike,
        liked: liked,
        likes: likes,
        size: styles/* ICON_SIZE */.ZG
    }), /*#__PURE__*/ react.createElement(styles/* ReportButton */.f4, {
        onClick: onReportIntent
    }, /*#__PURE__*/ react.createElement(tooltip/* Tooltip */.u, {
        placement: ui/* Direction.Left */.Nm.Left,
        title: t("feedback", "report-review.title")
    }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, {
        size: 20
    })))))) : null));
};
/* harmony default export */ const product = (/*#__PURE__*/(0,react.memo)(ProductUserReviewCard));


/***/ }),

/***/ 28127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": () => (/* binding */ Footer),
/* harmony export */   "$k": () => (/* binding */ Statistic),
/* harmony export */   "Bp": () => (/* binding */ FooterContent),
/* harmony export */   "Cq": () => (/* binding */ Review),
/* harmony export */   "I8": () => (/* binding */ Edit),
/* harmony export */   "IR": () => (/* binding */ UserReviewCard),
/* harmony export */   "Wn": () => (/* binding */ UserInfoText),
/* harmony export */   "ZG": () => (/* binding */ ICON_SIZE),
/* harmony export */   "ao": () => (/* binding */ UserInfo),
/* harmony export */   "f4": () => (/* binding */ ReportButton),
/* harmony export */   "f9": () => (/* binding */ UserInfoRow),
/* harmony export */   "g0": () => (/* binding */ ViaShopText),
/* harmony export */   "iK": () => (/* binding */ ViaShopTooltip),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "lb": () => (/* binding */ ThumbsUpIcon),
/* harmony export */   "zH": () => (/* binding */ ViaShop)
/* harmony export */ });
/* unused harmony exports FooterLink, ExternalPartner, EyeIcon */
/* harmony import */ var _prisjakt_ui_icon_eye__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41093);
/* harmony import */ var _prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79514);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5492);
/* harmony import */ var _prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5521);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33399);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87172);
/* harmony import */ var src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48892);
/* harmony import */ var src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24061);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10297);
/* harmony import */ var _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55840);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 100%;\n  align-items: flex-end;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-decoration: none;\n\n  &:hover {\n    color: ",
        ";\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  gap: ",
        ";\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        " {\n      > div {\n        width: unset !important;\n        > img {\n          width: 12px !important;\n          height: 12px !important;\n        }\n      }\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.4rem;\n  align-items: center;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  &::after {\n    color: ",
        ";\n    content: '|';\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    color: ",
        ";\n    line-height: 1.33333;\n    opacity: 1;\n    flex-grow: 0;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: ",
        "px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: ",
        ";\n\n  p {\n    margin: 0;\n  }\n\n  a {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n\n  ",
        ", ",
        " {\n    grid-area: 1 / 1 / 3 / 2;\n    align-self: center;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: flex-start;\n  gap: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  fill: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  position: relative;\n  font-weight: 600;\n\n  &:not(:last-of-type) {\n    margin-right: ",
        ";\n  }\n\n  ",
        ", ",
        " {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-left: auto;\n\n  path {\n    fill: ",
        ";\n  }\n\n  &:hover {\n    cursor: pointer;\n    path {\n      fill: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}










var ICON_SIZE = 20;
var Footer = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Footer",
    componentId: "sc-0-0"
})(_templateObject());
var FooterContent = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "FooterContent",
    componentId: "sc-0-1"
})(_templateObject1());
var FooterLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .BodySmallText */ .oI).withConfig({
    displayName: "FooterLink",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.text.linkExternal;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var Edit = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Edit",
    componentId: "sc-0-3"
})(_templateObject3());
var ExternalPartner = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .BodySmallText */ .oI).withConfig({
    displayName: "ExternalPartner",
    componentId: "sc-0-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.base400;
});
var UserReviewCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg).withConfig({
    displayName: "UserReviewCard",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, function(p) {
    return src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject5(), p.$expanded ? "margin: 0 ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";") : "\n    &:first-child {\n      margin-left: ".concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";\n    }\n\n    &:last-child {\n      margin-right: ").concat(src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ";\n    }\n    "));
});
var UserInfoRow = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "UserInfoRow",
    componentId: "sc-0-6"
})(_templateObject8(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .media.smallOnly */ .BC.smallOnly(_templateObject7(), src_components_rating_styles__WEBPACK_IMPORTED_MODULE_6__/* .StarsWrapper */ .gL));
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].span.withConfig({
    displayName: "Divider",
    componentId: "sc-0-7"
})(_templateObject9(), function(p) {
    return p.theme.text.quaternary;
});
var UserInfoText = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .CaptionText */ .HB).withConfig({
    displayName: "UserInfoText",
    componentId: "sc-0-8"
})(_templateObject10(), function(p) {
    return p.$bold ? p.theme.colors.base500 : p.theme.colors.base400;
});
var UserInfo = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "UserInfo",
    componentId: "sc-0-9"
})(_templateObject11(), _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .USER_AVATAR_SIZE */ .ZT, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.callToActionHover;
}, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .UserAvatarStyle */ .SD, _components_user_user_avatar__WEBPACK_IMPORTED_MODULE_9__/* .UserAvatarClickableStyle */ .$t);
var Review = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_list_variants__WEBPACK_IMPORTED_MODULE_1__/* .Column */ .sg).withConfig({
    displayName: "Review",
    componentId: "sc-0-10"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var ViaShop = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "ViaShop",
    componentId: "sc-0-11"
})(_templateObject13(), function(p) {
    return p.theme.colors.maybeBlue700;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall);
var ViaShopTooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(src_components_tooltip_new__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u).withConfig({
    displayName: "ViaShopTooltip",
    componentId: "sc-0-12"
})(_templateObject14());
var ViaShopText = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].span.withConfig({
    displayName: "ViaShopText",
    componentId: "sc-0-13"
})(_templateObject15(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ThumbsUpIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_icon_like_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconLikeFilled */ .G).withConfig({
    displayName: "ThumbsUpIcon",
    componentId: "sc-0-14"
})(_templateObject16(), function(p) {
    return p.theme.text.primary;
});
var EyeIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_prisjakt_ui_icon_eye__WEBPACK_IMPORTED_MODULE_0__/* .IconEye */ .t).withConfig({
    displayName: "EyeIcon",
    componentId: "sc-0-15"
})(_templateObject17(), function(p) {
    return p.theme.text.primary;
});
var Statistic = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({
    displayName: "Statistic",
    componentId: "sc-0-16"
})(_templateObject18(), src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, ThumbsUpIcon, EyeIcon, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var ReportButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_5__/* .Clickable */ .P).withConfig({
    displayName: "ReportButton",
    componentId: "sc-0-17"
})(_templateObject19(), function(p) {
    return p.theme.buttons.link.text;
}, function(p) {
    return p.theme.buttons.link.textHover;
});


/***/ })

}]);